import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { ErrorMessage, useFormik, FormikProvider, Field } from "formik";
import { Form, Table } from "react-bootstrap";
import * as OFMSUI from "react-bootstrap";
import Swal from "sweetalert2";
import ShowAlert from "../../alert";

import { useState } from "react";
import HousingService from "../../../Services/HousingService";
import { useHistory } from "react-router-dom";
import NavigationServicesHeader from "../../../Header/NavigationServicesHeader";
import { FaFastBackward } from "react-icons/fa";
import { allowAlphabetAndSpacesOnly, NumberValidation, OnlyNumbers } from "../../utils/commonFunctions";
function NewEmpRegistration() {
  const showNotification = (type, message) => {
    if (type === "success") {
      Swal.fire("Success", message, "success");
    } else if (type === "error") {
      Swal.fire("Error", message, "error");
    } else if (type === "warning") {
      Swal.fire("Warning", message, "warning");
    } else if (type === "info") {
      Swal.fire("info", message, "info");
    }
  };
  const history = useHistory();
  const [bankNamesList, setbankNamesList] = useState();
  const [districts, setDistricts] = useState([]);

  const [EmpTypeList, setEmpTypeList] = useState();

  const [prdesignationlist, setprdesignationlist] = useState();
  const [selectedEmpType, setSelectedEmpType] = useState("");
  const isValidIFSC = (ifsc) => {
    if (ifsc.length !== 11) {
      return false;
    }

    if (!/^[A-Z]{4}$/.test(ifsc.substring(0, 4))) {
      return false;
    }

    if (ifsc.charAt(4) !== "0") {
      return false;
    }

    if (!/^[0-9A-Za-z]{6}$/.test(ifsc.substring(5))) {
      return false;
    }

    return true;
  };

  const fieldNames = [
    "basic_pay_earnings",
    "per_pay_earnings",
    "spl_pay_earnings",
    "da_earnings",
    "hra_earnings",

    "cca_earnings",
    "gp_earnings",
    "ir_earnings",
    "medical_earnings",
    "ca_earnings",
    "spl_all",
    "misc_h_c",
    "addl_hra",
    "sca",
  ];
  const Earnings_3 = [
    "os_basic_pay_earnings",
    "os_hra_earnings",
    "os_medical_earnings",
    "os_ca_earnings",
    "os_performance_earnings",
    "os_ec_epf",
  ];
  const Deductions_3 = [
    "os_prof_tax_deductions",
    "os_ees_epf_deductions",
    "os_ers_epf_deductions",
    "os_other_deductions",
  ];
  const Earnings_4 = ["nmr_gross_earnings"];
  const Deductions_4 = [
    "os_prof_tax_deductions",
    "nmr_tds_deductions",
    "nmr_fa_deductions",
    "nmr_ea_deductions",
    "nmr_ma_deductions",
    "nmr_lic_deductions",
    "nmr_otherliab_deductions",
    "os_ees_epf_deductions",
    "nmr_postalrd_deductions",
  ];
  const deductionNames = [
    "gpfs_deductions",
    "gpfsa_deductions",
    "gpfl_deductions",
    "apglis_deductions",
    "apglil_deductions",
    "gis_deductions",
    "lic_deductions",
    "license_deductions",
    "con_decd_deductions",
    "epf_deductions",
    "epf_deductions1",
    "epf_l_deductions",
    "vpf_deductions",
    "ppf_deductions",
    "rcs_cont_deductions",
    "cmrf_deductions",
    "fcf_deductions",
    "house_rent_deductions",
    "sal_rec_deductions",
    "pt_deductions",
    "it_deductions",
    "other_deductions",
  ];

  const LoanDeductions = [
    "car_a_loanpi",
    "car_a_loanti",
    "car_a_loan",

    "car_i_loanpi",
    "car_i_loanti",
    "car_i_loan",

    "cyc_a_loanpi",
    "cyc_a_loanti",
    "cyc_a_loan",

    "cyc_i_loanpi",
    "cyc_i_loanti",
    "cyc_i_loan",

    "mca_a_loanpi",
    "mca_a_loanti",
    "mca_a_loan",

    "mca_i_loanpi",
    "mca_i_loanti",
    "mca_i_loan",

    "mar_a_loanti",
    "mar_a_loanti",
    "mar_a_loan",

    "mar_i_loanpi",
    "mar_i_loanti",
    "mar_i_loan",

    "med_a_loanpi",
    "med_a_loanti",
    "med_a_loan",

    "med_a_i_loanpi",
    "med_a_i_loanti",
    "med_a_i_loan",

    "hba_loanpi",
    "hba_loanti",
    "hba_loan",

    "add_hba_loanpi",
    "add_hba_loanti",
    "add_hba_loan",

    "hba1_loanpi",
    "hba1_loanti",
    "hba1_loan",

    "add_hba1_loanpi",
    "add_hba1_loanti",
    "add_hba1_loan",

    "comp_loanpi",
    "comp_loanti",
    "comp_loan",

    "comp1_loanpi",
    "comp1_loanti",
    "comp1_loan",

    "hcesa_loanpi",
    "hcesa_loanti",
    "hcesa_loan",

    "hcesa_i_loanpi",
    "hcesa_i_loanti",
    "hcesa_i_loan",

    "hbao_loanpi",
    "hbao_loanti",
    "hbao_loan",

    "vij_bank_loanpi",
    "vij_bank_loanti",
    "vij_bank_loan",

    "fa_loanpi",
    "fa_loanti",
    "fa_loan",

    "ea_loanpi",
    "ea_loanti",
    "ea_loan",

    "sfa_loanpi",
    "sfa_loanti",
    "sfa_loan ",

    "sal_adv_loanpi",
    "sal_adv_loanti",
    "sal_adv_loan",

    "hr_arrear_loanpi",
    "hr_arrear_loanti",
    "hr_arrear_loan",

    "cell_loanpi",
    "cell_loanti",
    "cell_loan",

    "staff_pl_loanpi",
    "staff_pl_loanti",
    "staff_pl_loan",

    "court_loanpi",
    "court_loanti",
    "court_loan",
  ];

  const formik = useFormik({
    initialValues: {
      emptype_id: "",
      district: "",
      working_status: "",
      firstname: "",
      lastname: "",
      surname: "",
      fathername: "",
      sex: "",
      bank_name: "",
      ifsc: "",
      account_no: "",
      branch_code: "",
      prefix: "",
      emp_type: "",
      //==================Totals===============//
      totalEarnings: "",
      totalDeductions: "",
      totalloanAdvances: "",
      totalDeductions_3: "",
      totalEarnings_3: "",
      netSalary: "",
      netSalary_3: "",
      totalDeductions_4: "",
      totalEarnings_4: "",
      netSalary_4: "",
      Earnings_4: "",
      Deductions_4: "",
      //==================Earnings===============//
      basic_pay_earnings: "",
      per_pay_earnings: "",
      spl_pay_earnings: "",
      da_earnings: "",
      hra_earnings: "",
      cca_earnings: "",
      gp_earnings: "",
      ir_earnings: "",
      medical_earnings: "",
      ca_earnings: "",
      spl_all: "",
      misc_h_c: "",
      addl_hra: "",
      sca: "",

      //===========>Deductions<================//
      gpfs_deductions: "",
      gpfsa_deductions: "",
      gpfl_deductions: "",
      apglis_deductions: "",
      apglil_deductions: "",
      gis_deductions: "",
      lic_deductions: "",
      license_deductions: "",
      con_decd_deductions: "",
      epf_deductions: "",
      epf_deductions1: "",
      epf_l_deductions: "",
      vpf_deductions: "",
      ppf_deductions: "",
      rcs_cont_deductions: "",
      cmrf_deductions: "",
      fcf_deductions: "",
      house_rent_deductions: "",
      sal_rec_deductions: "",
      pt_deductions: "",
      it_deductions: "",
      // postal_deductions: "",
      other_deductions: "",
      cca_deductions: "",
      designation: "",

      //=====================Principal PI =================================
      car_a_loanpi: "",
      cyc_a_loanpi: "",
      mca_a_loanpi: "",
      mar_a_loanpi: "",
      med_a_loanpi: "",
      hba_loanpi: "",
      add_hba_loanpi: "",
      comp_loanpi: "",
      hcesa_loanpi: "",
      hcesa_loan: "",
      hbao_loanpi: "",
      fa_loanpi: "",

      sfa_loanpi: "",
      hr_arrear_loanpi: "",
      staff_pl_loanpi: "",

      //=====================Principal TI=============================

      cyc_a_loanti: "",
      cyclePriTI: "",
      mca_a_loanti: "",
      mar_a_loanti: "",
      med_a_loanti: "",
      hba_loanti: "",
      add_hba_loanti: "",
      comp_loanti: "",
      hcesa_loanti: "",
      hbao_loanti: "",
      fa_loanti: "",

      hr_arrear_loanti: "",
      staff_pl_loanti: "",

      //=====================Principal Amount===========================

      car_a_loan: "",
      cyc_a_loan: "",
      cyclePriamount: "",
      mca_a_loan: "",
      mar_a_loan: "",
      med_a_loan: "",
      hba_loan: "",
      add_hba_loan: "",
      comp_loan: "",
      hcesaPriamount: "",
      hbao_loan: "",
      fa_loan: "",

      sfa_loan: "",
      hr_arrear_loan: "",
      staff_pl_loan: "",
      //=====================Interest PI=================================

      car_i_loanpi: "",
      cyc_i_loanpi: "",
      mca_i_loanpi: "",
      mar_i_loanpi: "",
      med_a_i_loanpi: "",
      hba1_loanpi: "",
      add_hba1_loanpi: "",
      comp1_loanti: "",
      hcesa_i_loanpi: "",
      vij_bank_loanpi: "",
      vij_bank_loanti: "",
      vij_bank_loan: "",
      faIntPI: "",
      ea_loanpi: "",

      sal_adv_loanpi: "",
      cell_loanpi: "",
      court_loanpi: "",
      sfa_loanti: "",

      //=====================Interest TI=================================

      car_i_loanti: "",
      cyc_i_loanti: "",
      mca_i_loanti: "",
      mar_i_loanti: "",
      med_a_i_loanti: "",
      hba1_loanti: "",
      add_hba1_loanti: "",
      comp1_loanpi: "",
      hcesa_i_loanti: "",
      hbaotherIntTI: "",
      faIntTI: "",
      ea_loanti: "",

      sal_adv_loanti: "",
      cell_loanti: "",
      court_loanti: "",

      //=====================Interest Amount=================================

      car_i_loan: "",
      cyc_i_loan: "",
      mca_i_loan: "",
      mar_i_loan: "",
      med_a_i_loan: "",
      hba1_loan: "",
      add_hba1_loan: "",
      comp1_loan: "",
      hcesa_i_loan: "",
      hbaotherIntAmount: "",
      faIntAmount: "",
      ea_loan: "",

      sal_adv_loan: "",
      cell_loan: "",
      court_loan: "",
      //=================>Consultant<=========================================
      os_location: "",
      os_work_place: "",
      os_basic_pay_earnings: "",
      os_hra_earnings: "",
      os_medical_earnings: "",
      os_ca_earnings: "",
      os_performance_earnings: "",
      os_ec_epf: "",
      os_prof_tax_deductions: "",
      os_ees_epf_deductions: "",
      os_ers_epf_deductions: "",
      os_other_deductions: "",
      nmr_gross_earnings: "",
      //==============>NMR<==============================
      nmr_tax_deductions: "",
      nmr_tds_deductions: "",
      nmr_fa_deductions: "",
      nmr_ea_deductions: "",
      nmr_ma_deductions: "",
      nmr_lic_deductions: "",
      nmr_otherliab_deductions: "",
      nmr_postalrd_deductions: "",
    },
    validate: (values) => {
      const errors = {};

      const alphaRegex = /^[A-Za-z\s]+$/;
      const bankNameRegex = /^[A-Za-z\s.&-]+$/;
      const numberRegex = /^[0-9]+$/;

      if (!values.prefix) {
        errors.prefix = "Select prefix";
      } else if (!alphaRegex.test(values.prefix)) {
        errors.prefix = "Prefix should contain only alphabets";
      }

      if (!values.firstname) {
        errors.firstname = "Enter firstname";
      } else if (!alphaRegex.test(values.firstname)) {
        errors.firstname = "Firstname should contain only alphabets";
      }

      if (!values.lastname) {
        errors.lastname = "Enter lastname";
      } else if (!alphaRegex.test(values.lastname)) {
        errors.lastname = "Lastname should contain only alphabets";
      }

      if (!values.surname) {
        errors.surname = "Enter surname";
      } else if (!alphaRegex.test(values.surname)) {
        errors.surname = "Surname should contain only alphabets";
      }

      if (!values.fathername) {
        errors.fathername = "Enter fathername";
      } else if (!alphaRegex.test(values.fathername)) {
        errors.fathername = "Father name should contain only alphabets";
      }

      if (!values.district) {
        errors.district = "Select district";
      }

      if (!values.emp_type) {
        errors.emp_type = "Select employee type";
      }

      if (!values.sex) {
        errors.sex = "Select gender";
      }

      if (!values.bank_name) {
        errors.bank_name = "Select bank name";
      }

      if (!values.designation) {
        errors.designation = "Select designation";
      }

      if (!values.account_no) {
        errors.account_no = "Enter account number";
      } else if (!numberRegex.test(values.account_no)) {
        errors.account_no = "Account number should contain only numbers";
      }


      if (!values.branch_code) {
        errors.branch_code = "Enter branch code";
      } else if (!numberRegex.test(values.branch_code)) {
        errors.branch_code = "Branch code should contain only numbers";
      }

      if (!values.ifsc) {
        errors.ifsc = "Enter IFSC code";
      } else if (!isValidIFSC(values.ifsc)) {
        errors.ifsc = "Invalid IFSC code";
      }

      return errors;
    },
    onSubmit: async (values) => {
      console.log(values);
      // setTableEnable(true);
      // setViewEnable(false);
      console.log("formik.values.emp_type:::", formik.values.emp_type);
      if (formik.values.emp_type === "1" || formik.values.emp_type === "2" || formik.values.emp_type === "5") {
        // console.log("formik.values.emp_type:::",1);
        ConfirmEmpUpdateReport();

      }
      else if (formik.values.emp_type === "3") {
        // console.log("formik.values.emp_type:::", formik.values.emp_type);
        // console.log("formik.values.emp_type:::",3);

        ConfirmEmpUpdateReport3();
      }
      else {
        // console.log("formik.values.emp_type:::", formik.values.emp_type);
        // console.log("formik.values.emp_type:::",4);
        ConfirmEmpUpdateReport4();
      }

      // setSelectedEmpType("");
    },
  });

  const sumFieldNames = fieldNames.reduce(
    (total, fieldName) => total + parseFloat(formik.values[fieldName] || 0),
    0
  );
  const sumDeductions = deductionNames.reduce(
    (total, deductionName) =>
      total + parseFloat(formik.values[deductionName] || 0),
    0
  );
  const sumLoanDeductions = LoanDeductions.reduce(
    (total, LoanDeduction) =>
      total + parseFloat(formik.values[LoanDeduction] || 0),
    0
  );
  const totalSum = sumFieldNames - sumDeductions - sumLoanDeductions;

  const sumFieldNames_3 = Earnings_3.reduce(
    (total, Earnings_3) => total + parseFloat(formik.values[Earnings_3] || 0),
    0
  );
  const sumDeductions_3 = Deductions_3.reduce(
    (total, Deductions_3) =>
      total + parseFloat(formik.values[Deductions_3] || 0),
    0
  );

  const totalSum_3 = sumFieldNames_3 - sumDeductions_3;

  const sumFieldNames_4 = Earnings_4.reduce(
    (total, Earnings_4) => total + parseFloat(formik.values[Earnings_4] || 0),
    0
  );
  const sumDeductions_4 = Deductions_4.reduce(
    (total, Deductions_4) =>
      total + parseFloat(formik.values[Deductions_4] || 0),
    0
  );

  const totalSum_4 = sumFieldNames_4 - sumDeductions_4;

  React.useEffect(() => {
    HousingService.CGG_District().then((res) => {
      if (res.data) {
        let options = res.data.map((item, i) => {
          return (
            <option key={i} value={item.code}>
              {item.name}
            </option>
          );
        });
        setDistricts(options);
      }
    });
    HousingService.getCadreWiseDesignationDropdownlist().then((res) => {
      if (res.data) {
        let options = res.data.map((item, i) => {
          if (item !== null) {
            return (
              <option key={i} value={item.designation_id}>
                {item.designation_name}
              </option>
            );
          }
        });
        setprdesignationlist(options);
      }
    });
    HousingService.fetchBankName().then((res) => {
      if (res.data) {
        let options = res.data.map((item, i) => {
          if (item !== null) {
            return (
              <option key={i} value={item.bankid}>
                {item.bankfullname}
              </option>
            );
          }
        });
        setbankNamesList(options);
      }
    });
    HousingService.fetchEmptypeList().then((res) => {
      if (res.data) {
        let options = res.data.map((item, i) => {
          return (
            <option key={i} value={item.emptype_id}>
              {item.emptype_name}
            </option>
          );
        });
        setEmpTypeList(options);
      }
    });
  }, []);

  const ConfirmEmpUpdateReport = () => {
    let param125 = {
      prefix: formik.values.prefix,
      firstname: formik.values.firstname,
      lastname: formik.values.lastname,
      surname: formik.values.surname,
      fathername: formik.values.fathername,
      dist_code: formik.values.district,
      emptype_id: selectedEmpType,
      sex: formik.values.sex,
      designation: formik.values.designation,
      account_no: formik.values.account_no,
      bank_name: formik.values.bank_name,
      branch_code: formik.values.branch_code,
      ifsc: formik.values.ifsc,

      //======================>Earnings<==================================
      basic_pay_earnings: formik.values.basic_pay_earnings,
      per_pay_earnings: formik.values.per_pay_earnings,
      spl_pay_earnings: formik.values.spl_pay_earnings,
      da_earnings: formik.values.da_earnings,
      hra_earnings: formik.values.hra_earnings,
      cca_earnings: formik.values.cca_earnings,
      gp_earnings: formik.values.gp_earnings,
      ir_earnings: formik.values.ir_earnings,
      medical_earnings: formik.values.medical_earnings,
      ca_earnings: formik.values.ca_earnings,
      spl_all: formik.values.spl_all,
      misc_h_c: formik.values.misc_h_c,
      addl_hra: formik.values.addl_hra,
      sca: formik.values.sca,

      //======================>Deductions<==================================

      gpfs_deductions: formik.values.gpfs_deductions,
      gpfl_deductions: formik.values.gpfl_deductions,
      gpfsa_deductions: formik.values.gpfsa_deductions,
      house_rent_deductions: formik.values.house_rent_deductions,
      gis_deductions: formik.values.gis_deductions,
      pt_deductions: formik.values.pt_deductions,
      it_deductions: formik.values.it_deductions,
      cca_deductions: formik.values.cca_deductions,
      license_deductions: formik.values.license_deductions,
      con_decd_deductions: formik.values.con_decd_deductions,
      lic_deductions: formik.values.lic_deductions,
      rcs_cont_deductions: formik.values.rcs_cont_deductions,
      sal_rec_deductions: formik.values.sal_rec_deductions,
      cmrf_deductions: formik.values.cmrf_deductions,
      fcf_deductions: formik.values.fcf_deductions,
      epf_l_deductions: formik.values.epf_l_deductions,
      vpf_deductions: formik.values.vpf_deductions,
      apglis_deductions: formik.values.apglis_deductions,
      apglil_deductions: formik.values.apglil_deductions,
      epf_deductions: formik.values.epf_deductions,
      ppf_deductions: formik.values.ppf_deductions,
      other_deductions: formik.values.other_deductions,
      //======================>Loan advances<==================================

      car_a_loan: formik.values.car_a_loan,
      car_a_loanpi: formik.values.car_a_loanpi,
      car_a_loanti: formik.values.car_a_loanti,

      car_i_loanpi: formik.values.car_i_loanpi,
      car_i_loanti: formik.values.car_i_loanti,
      car_i_loan: formik.values.car_i_loan,

      cyc_i_loanpi: formik.values.cyc_i_loanpi,
      cyc_i_loanti: formik.values.cyc_i_loanti,
      cyc_i_loan: formik.values.cyc_i_loan,

      cyc_a_loanpi: formik.values.cyc_a_loanpi,
      cyc_a_loanti: formik.values.cyc_a_loanti,
      cyc_a_loan: formik.values.cyc_a_loan,

      mca_i_loanpi: formik.values.mca_i_loanpi,
      mca_i_loanti: formik.values.mca_i_loanti,
      mca_i_loan: formik.values.mca_i_loan,

      mca_a_loanpi: formik.values.mca_a_loanpi,
      mca_a_loanti: formik.values.mca_a_loanti,
      mca_a_loan: formik.values.mca_a_loan,

      mar_a_loanpi: formik.values.mar_a_loanpi,
      mar_a_loanti: formik.values.mar_a_loanti,
      mar_a_loan: formik.values.mar_a_loan,

      mar_i_loanpi: formik.values.mar_i_loanpi,
      mar_i_loanti: formik.values.mar_i_loanti,
      mar_i_loan: formik.values.mar_i_loan,

      med_a_loanpi: formik.values.med_a_loanpi,
      med_a_loanti: formik.values.med_a_loanti,
      med_a_loan: formik.values.med_a_loan,

      med_a_i_loanpi: formik.values.med_a_i_loanpi,
      med_a_i_loanti: formik.values.med_a_i_loanti,
      med_a_i_loan: formik.values.med_a_i_loan,

      hba_loanpi: formik.values.hba_loanpi,
      hba_loanti: formik.values.hba_loanti,
      hba_loan: formik.values.hba_loan,

      hba1_loanpi: formik.values.hba1_loanpi,
      hba1_loanti: formik.values.hba1_loanti,
      hba1_loan: formik.values.hba1_loan,

      add_hba_loanpi: formik.values.add_hba_loanpi,
      add_hba_loanti: formik.values.add_hba_loanti,
      add_hba1_loan: formik.values.add_hba1_loan,

      comp_loanpi: formik.values.comp_loanpi,
      comp_loanti: formik.values.comp_loanti,
      comp_loan: formik.values.comp_loan,

      comp1_loanpi: formik.values.comp1_loanpi,
      comp1_loanti: formik.values.comp1_loanti,
      comp1_loan: formik.values.comp1_loan,

      hcesa_loanpi: formik.values.hcesa_loanpi,
      hcesa_loanti: formik.values.hcesa_loanti,
      hcesa_loan: formik.values.hcesa_loan,

      hcesa_i_loanpi: formik.values.hcesa_i_loanpi,
      hcesa_i_loanti: formik.values.hcesa_i_loanti,
      hcesa_i_loan: formik.values.hcesa_i_loan,

      hbao_loanpi: formik.values.hbao_loanpi,
      hbao_loanti: formik.values.hbao_loanti,
      hbao_loan: formik.values.hbao_loan,

      vij_bank_loanpi: formik.values.vij_bank_loanpi,
      vij_bank_loanti: formik.values.vij_bank_loanti,
      vij_bank_loan: formik.values.vij_bank_loan,

      fa_loanpi: formik.values.fa_loanpi,
      fa_loanti: formik.values.fa_loanti,
      fa_loan: formik.values.fa_loan,

      ea_loanpi: formik.values.ea_loanpi,
      ea_loanti: formik.values.ea_loanti,
      ea_loan: formik.values.ea_loan,

      sal_adv_loanpi: formik.values.sal_adv_loanpi,
      sal_adv_loanti: formik.values.sal_adv_loanti,
      sal_adv_loan: formik.values.sal_adv_loan,

      hr_arrear_loanpi: formik.values.hr_arrear_loanpi,
      hr_arrear_loanti: formik.values.hr_arrear_loanti,
      hr_arrear_loan: formik.values.hr_arrear_loan,

      cell_loanpi: formik.values.cell_loanpi,
      cell_loanti: formik.values.cell_loanti,
      cell_loan: formik.values.cell_loan,

      staff_pl_loanpi: formik.values.staff_pl_loanpi,
      staff_pl_loanti: formik.values.staff_pl_loanti,
      staff_pl_loan: formik.values.staff_pl_loan,

      court_loanpi: formik.values.court_loanpi,
      court_loanti: formik.values.court_loanti,
      court_loan: formik.values.court_loan,

      sfa_loanpi: formik.values.sfa_loanpi,
      sfa_loanti: formik.values.sfa_loanti,
      sfa_loan: formik.values.sfa_loan,
    };
    console.log("param125");
    Swal.fire({
      text: "Are You Sure?",
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes",
    }).then((result) => {
      if (result.isConfirmed) {
        HousingService.NewEmpRegistration125(param125).then((res) => {
          if (res.data[0].responseMsg === "Data uploaded Successfully") {
            Swal.fire({ icon: "success", title: "Success", text: "Registered Successfully", confirmButtonText: "OK", }).then(() => {
              history.go(0);
            });
          }
          else {
            ShowAlert("Some error occured",
              "error");
          }
        });
      }
    });
  };
  const ConfirmEmpUpdateReport3 = () => {
    let param3 = {
      prefix: formik.values.prefix,
      firstname: formik.values.firstname,
      lastname: formik.values.lastname,
      surname: formik.values.surname,
      fathername: formik.values.fathername,
      dist_code: formik.values.district,
      emptype_id: selectedEmpType,
      sex: formik.values.sex,
      designation: formik.values.designation,
      account_no: formik.values.account_no,
      bank_name: formik.values.bank_name,
      branch_code: formik.values.branch_code,
      ifsc: formik.values.ifsc,

      //================> type 3<=====================================
      os_work_place: formik.values.os_work_place,
      os_location: formik.values.os_location,

      os_basic_pay_earnings: formik.values.os_basic_pay_earnings,
      os_hra_earnings: formik.values.os_hra_earnings,
      os_medical_earnings: formik.values.os_medical_earnings,

      os_ca_earnings: formik.values.os_ca_earnings,
      os_performance_earnings: formik.values.os_performance_earnings,
      os_ec_epf: formik.values.os_ec_epf,

      os_prof_tax_deductions: formik.values.os_prof_tax_deductions,
      os_ees_epf_deductions: formik.values.os_ees_epf_deductions,
      os_ers_epf_deductions: formik.values.os_ers_epf_deductions,

      os_other_deductions: formik.values.os_other_deductions,
    };
    console.log(param3);
    Swal.fire({
      text: "Are You Sure?",
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes",
    }).then((result) => {
      if (result.isConfirmed) {
        HousingService.NewEmpRegistration3(param3).then((res) => {
          if (res.data[0].responseMsg === "Data uploaded Successfully") {
            Swal.fire({
              icon: "success", title: "Success", text: "Registered Successfully",
              confirmButtonText: "OK",
            }).then(() => { history.go(0); });
          }
          else {
            ShowAlert("Some error occured", "error");
          }
        });
      }
    });
  };
  const ConfirmEmpUpdateReport4 = () => {
    let param4 = {
      prefix: formik.values.prefix,
      firstname: formik.values.firstname,
      lastname: formik.values.lastname,
      surname: formik.values.surname,
      fathername: formik.values.fathername,
      dist_code: formik.values.district,
      emptype_id: selectedEmpType,
      sex: formik.values.sex,
      designation: formik.values.designation,
      account_no: formik.values.account_no,
      bank_name: formik.values.bank_name,
      branch_code: formik.values.branch_code,
      ifsc: formik.values.ifsc,
      //================> type 4<=====================================
      os_work_place: formik.values.os_work_place,
      os_location: formik.values.os_location,
      nmr_gross_earnings: formik.values.nmr_gross_earnings,
      os_ees_epf_deductions: formik.values.os_ees_epf_deductions,
      os_prof_tax_deductions: formik.values.os_prof_tax_deductions,
      nmr_postalrd_deductions: formik.values.nmr_postalrd_deductions,

      nmr_tds_deductions: formik.values.nmr_tds_deductions,
      nmr_fa_deductions: formik.values.nmr_fa_deductions,
      nmr_ea_deductions: formik.values.nmr_ea_deductions,

      nmr_ma_deductions: formik.values.nmr_ma_deductions,
      nmr_lic_deductions: formik.values.nmr_lic_deductions,
      nmr_otherliab_deductions: formik.values.nmr_otherliab_deductions,
    };
    console.log(param4);
    Swal.fire({
      text: "Are You Sure?",
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes",
    }).then((result) => {
      if (result.isConfirmed) {
        HousingService.NewEmpRegistration4(param4).then((res) => {
          if (res.data[0].responseMsg === "Data uploaded Successfully") { Swal.fire({ icon: "success", title: "Success", text: "Registered Successfully", confirmButtonText: "OK", }).then(() => { history.go(0); }); } else { ShowAlert("Some error occured", "error"); }
        });
      }
    });
  };

  // const NumberValidation = (e) => {
  //   var keyCode = e.keyCode === 0 ? e.charCode : e.keyCode;

  //   if ((keyCode >= 48 && keyCode <= 57) || keyCode === 46) {
  //     var value = Number(e.target.value + e.key) || 0;
  //     return isValidNumber(value);
  //   } else {
  //     e.preventDefault();
  //     showNotification("warning", "Enter digits only");
  //     return false;
  //   }
  // };

  function isValidNumber(number) {
    return 0 <= number && number <= 10;
  }
  const calculateDAPercentage = () => {
    const { basic_pay_earnings, da_earnings } = formik.values;

    if (!basic_pay_earnings || !da_earnings) return 0;

    const percentage = (da_earnings / basic_pay_earnings) * 100;
    return percentage.toFixed(2);
  };
  const calculateHRAPercentage = () => {
    const { basic_pay_earnings, hra_earnings } = formik.values;

    if (!basic_pay_earnings || !hra_earnings) return 0;

    const percentage = (hra_earnings / basic_pay_earnings) * 100;
    return percentage.toFixed(2);
  };
  const calculateIRPercentage = () => {
    const { basic_pay_earnings, ir_earnings } = formik.values;

    if (!basic_pay_earnings || !ir_earnings) return 0;

    const percentage = (ir_earnings / basic_pay_earnings) * 100;
    return percentage.toFixed(2);
  };
  const calculateEPFPercentage = () => {
    const { basic_pay_earnings, epf_deductions } = formik.values;

    if (!basic_pay_earnings || !epf_deductions) return 0;

    const percentage = (epf_deductions / basic_pay_earnings) * 100;
    return percentage.toFixed(2);
  };
  return (
    <>
      <NavigationServicesHeader />

      <OFMSUI.Container fluid style={{ width: "90%" }}>
        <OFMSUI.Row>
          <OFMSUI.Col
            xs={12}
            sm={12}
            md={12}
            lg={6}
            xl={6}
            xxl={6}
            className="page-titlespacing"
          >
            <div className="inner-herbpage-service-title1">
              <h1 style={{ marginLeft: "-15px" }}>
                New Employee Registration
              </h1>
            </div>
          </OFMSUI.Col>

          <OFMSUI.Col
            xs={12}
            sm={12}
            md={12}
            lg={6}
            xl={6}
            xxl={6}
            className="page-titlespacing"
          >
            <button
              className="btn btn-primary btn-sm"
              style={{
                textAlign: "right", float: "right", marginTop: "30px", backgroundColor: "#603913", borderColor: "#603913", color: "#fff"
              }}
              type="reset"
              onClick={() => history.goBack()}
            >
              <FaFastBackward /> &nbsp;Back
            </button>
          </OFMSUI.Col>
        </OFMSUI.Row>
      </OFMSUI.Container>
      <OFMSUI.Container
        className="outer-page-content-container"
        fluid
        style={{ width: "90%" }}
      >
        <FormikProvider value={formik}>
          <Form onSubmit={formik.handleSubmit}>
            <>
              <Table bordered>
                <tbody>
                  <div style={{ textAlign: "left" }}>
                    <h5 style={{ color: "#004687" }}>
                      <b style={{ color: "#0e6793" }}>
                        <u>
                          {" "}
                          <h4 style={{ fontFamily: "times new roman" }}>
                            Personal Details
                          </h4>
                        </u>
                      </b>
                    </h5>
                  </div>
                  <div class="col-md-60">
                    <OFMSUI.Row>
                      <OFMSUI.Col
                        xs={12}
                        sm={12}
                        md={12}
                        lg={3}
                        xl={3}
                        xxl={3}
                        className=""
                      >
                        <th style={{ fontFamily: "roboto" }}>Prefix</th>

                        <Field
                          name="prefix"
                                                component="select"

                          maxLength={5}
                          className={
                            formik.touched.prefix && formik.errors.prefix
                              ? "form-control is-invalid"
                              : "form-control"
                          }
                          onChange={formik.handleChange}
                          value={formik.values.prefix}
                        >
                                                <option value="">Select</option>
                          
                                                                      <option value="MR">MR</option>
                                                <option value="Mrs.">Mrs.</option>
                                                <option value="SMT">SMT</option>
                                                <option value="Mr.">Mr.</option>
                                                <option value="Ms.">Ms.</option>
                                                <option value="Smt">Smt</option>
                                                <option value="Mr">Mr</option>
                                                <option value="Sri">Sri</option>
                                              </Field>
                        {formik.touched.prefix && formik.errors.prefix && (
                          <div className="invalid-feedback">
                            {formik.errors.prefix}
                          </div>
                        )}
                      </OFMSUI.Col>
                      <OFMSUI.Col
                        xs={12}
                        sm={12}
                        md={12}
                        lg={3}
                        xl={3}
                        xxl={3}
                        className=""
                      >
                        <th style={{ fontFamily: "roboto" }}> First Name</th>

                        <Field
                          name="firstname"
                          onChange={(e) => {
                            formik.handleChange(e);
                          }}
                          onKeyPress={(e) => allowAlphabetAndSpacesOnly(e)}
                          maxLength={50}
                          type="text"
                          className={
                            formik.touched.firstname && formik.errors.firstname
                              ? "form-control is-invalid"
                              : "form-control"
                          }
                        />
                        {formik.touched.firstname && formik.errors.firstname ? (
                          <div className="invalid-feedback">
                            {formik.errors.firstname}
                          </div>
                        ) : null}
                      </OFMSUI.Col>
                      <OFMSUI.Col
                        xs={12}
                        sm={12}
                        md={12}
                        lg={3}
                        xl={3}
                        xxl={3}
                        className=""
                      >
                        <th style={{ fontFamily: "roboto" }}>Last Name</th>

                        <Field
                          name="lastname"
                          onChange={(e) => {
                            formik.handleChange(e);
                          }}
                          onKeyPress={(e) => allowAlphabetAndSpacesOnly(e)}
                          maxLength={50}
                          type="text"
                          className={
                            formik.touched.lastname && formik.errors.lastname
                              ? "form-control is-invalid"
                              : "form-control"
                          }
                        />
                        {formik.touched.lastname && formik.errors.lastname ? (
                          <div className="invalid-feedback">
                            {formik.errors.lastname}
                          </div>
                        ) : null}
                      </OFMSUI.Col>
                      <OFMSUI.Col
                        xs={12}
                        sm={12}
                        md={12}
                        lg={3}
                        xl={3}
                        xxl={3}
                        className=""
                      >
                        <th style={{ fontFamily: "roboto" }}>Surname</th>

                        <Field
                          name="surname"
                          onChange={(e) => {
                            formik.handleChange(e);
                          }}
                          onKeyPress={(e) => allowAlphabetAndSpacesOnly(e)}
                          maxLength={50}
                          type="text"
                          className={
                            formik.touched.surname && formik.errors.surname
                              ? "form-control is-invalid"
                              : "form-control"
                          }
                        />
                        {formik.touched.surname && formik.errors.surname ? (
                          <div className="invalid-feedback">
                            {formik.errors.surname}
                          </div>
                        ) : null}
                      </OFMSUI.Col>
                      <OFMSUI.Col
                        xs={12}
                        sm={12}
                        md={12}
                        lg={3}
                        xl={3}
                        xxl={3}
                        className=""
                      >
                        <th style={{ fontFamily: "roboto" }}>Father name:</th>

                        <Field
                          name="fathername"
                          onChange={(e) => {
                            formik.handleChange(e);
                          }}
                          onKeyPress={(e) => allowAlphabetAndSpacesOnly(e)}
                          maxLength={50}
                          type="text"
                          className={
                            formik.touched.fathername &&
                              formik.errors.fathername
                              ? "form-control is-invalid"
                              : "form-control"
                          }
                        />
                        {formik.touched.fathername &&
                          formik.errors.fathername ? (
                          <div className="invalid-feedback">
                            {formik.errors.fathername}
                          </div>
                        ) : null}
                      </OFMSUI.Col>
                      <OFMSUI.Col
                        xs={12}
                        sm={12}
                        md={12}
                        lg={3}
                        xl={3}
                        xxl={3}
                        className=""
                      >
                        <th style={{ fontFamily: "roboto" }}> District</th>

                        <Field
                          name="district"
                          className={
                            formik.touched.district && formik.errors.district
                              ? "form-control is-invalid"
                              : "form-control"
                          }
                          onChange={(e) => {
                            formik.handleChange(e);
                          }}
                          component="select"
                        >
                          <option>Select</option>
                          {districts}
                        </Field>
                      </OFMSUI.Col>
                      <OFMSUI.Col
                        xs={12}
                        sm={12}
                        md={12}
                        lg={3}
                        xl={3}
                        xxl={3}
                        className=""
                      >
                        <th style={{ fontFamily: "roboto" }}>Gender</th>

                        <Field
                          name="sex"
                          component="select"
                          onChange={(e) => {
                            formik.handleChange(e);
                          }}
                          className={
                            formik.touched.sex && formik.errors.sex
                              ? "form-control is-invalid"
                              : "form-control"
                          }
                        >
                          <option value="">Select</option>
                          <option value="M">Male</option>
                          <option value="F">Female</option>
                        </Field>
                      </OFMSUI.Col>
                      <OFMSUI.Col
                        xs={12}
                        sm={12}
                        md={12}
                        lg={3}
                        xl={3}
                        xxl={3}
                        className=""
                      >
                        <th style={{ fontFamily: "roboto" }}> Employee Type</th>

                        <Field
                          name="emp_type"
                          className={
                            formik.touched.emp_type && formik.errors.emp_type
                              ? "form-control is-invalid"
                              : "form-control"
                          }
                          onChange={(e) => {
                            formik.handleChange(e);
                            setSelectedEmpType(e.target.value);
                          }}
                          component="select"
                        >
                          <option>Select</option>
                          {EmpTypeList}
                        </Field>
                      </OFMSUI.Col>
                      <OFMSUI.Col
                        xs={12}
                        sm={12}
                        md={12}
                        lg={3}
                        xl={3}
                        xxl={3}
                        className=""
                      >
                        <th style={{ fontFamily: "roboto" }}>Bank Name</th>

                        <Field
                          component="select"
                          name="bank_name"
                          className={
                            formik.touched.bank_name && formik.errors.bank_name
                              ? "form-control is-invalid"
                              : "form-control"
                          }
                        >
                          <option value="">--Select--</option>
                          {bankNamesList}
                        </Field>
                      </OFMSUI.Col>

                      <OFMSUI.Col
                        xs={12}
                        sm={12}
                        md={12}
                        lg={3}
                        xl={3}
                        xxl={3}
                        className=""
                      >
                        <th style={{ fontFamily: "roboto" }}>Branch Code</th>

                        <Field
                          name="branch_code"
                          onChange={(e) => {
                            formik.handleChange(e);
                          }}
                          className={
                            formik.touched.branch_code &&
                              formik.errors.branch_code
                              ? "form-control is-invalid"
                              : "form-control"
                          }
                          onKeyPress={OnlyNumbers}
                          maxLength={10}

                        />
                        {formik.touched.branch_code &&
                          formik.errors.branch_code ? (
                          <div className="invalid-feedback">
                            {formik.errors.branch_code}
                          </div>
                        ) : null}
                      </OFMSUI.Col>
                      <OFMSUI.Col
                        xs={12}
                        sm={12}
                        md={12}
                        lg={3}
                        xl={3}
                        xxl={3}
                        className=""
                      >
                        <th style={{ fontFamily: "roboto" }}>Account No.</th>

                        <Field
                          name="account_no"
                          onChange={(e) => {
                            formik.handleChange(e);
                          }}
                          type="text"
                          className={
                            formik.touched.account_no &&
                              formik.errors.account_no
                              ? "form-control is-invalid"
                              : "form-control"
                          }
                          onKeyPress={OnlyNumbers}
                          maxLength={24}
                          minLength={11}
                        />
                        {formik.touched.account_no &&
                          formik.errors.account_no ? (
                          <div className="invalid-feedback">
                            {formik.errors.account_no}
                          </div>
                        ) : null}
                      </OFMSUI.Col>
                      <OFMSUI.Col
                        xs={12}
                        sm={12}
                        md={12}
                        lg={3}
                        xl={3}
                        xxl={3}
                        className=""
                      >
                        <th style={{ fontFamily: "roboto" }}>IFSC Code</th>

                        <Field
                          name="ifsc"
                          onChange={(e) => {
                            formik.handleChange(e);
                          }}
                          type="text"
                          className={
                            formik.touched.ifsc && formik.errors.ifsc
                              ? "form-control is-invalid"
                              : "form-control"
                          }
                        />
                        {formik.touched.ifsc && formik.errors.ifsc ? (
                          <div className="invalid-feedback">
                            {formik.errors.ifsc}
                          </div>
                        ) : null}
                      </OFMSUI.Col>
                      <OFMSUI.Col
                        xs={12}
                        sm={12}
                        md={12}
                        lg={3}
                        xl={3}
                        xxl={3}
                        className=""
                      >
                        <th style={{ fontFamily: "roboto" }}>Designation</th>

                        <Field
                          name="designation"
                          component="select"
                          onChange={(e) => {
                            formik.handleChange(e);
                          }}
                          className={
                            formik.touched.designation &&
                              formik.errors.designation
                              ? "form-control is-invalid"
                              : "form-control"
                          }
                        >
                          <option value="">Select</option>
                          {prdesignationlist}
                        </Field>
                        {formik.touched.designation && formik.errors.designation ? (
                          <div className="invalid-feedback">
                            {formik.errors.designation}
                          </div>
                        ) : null}
                      </OFMSUI.Col>
                    </OFMSUI.Row>
                  </div>
                </tbody>
              </Table>
            </>

            {(selectedEmpType === "1" ||
              selectedEmpType === "2" ||
              selectedEmpType === "5") && (
                <>
                  <div style={{ textAlign: "left" }}>
                    <h5 style={{ color: "#004687" }}>
                      <b style={{ color: "#0e6793" }}>
                        <u>
                          {" "}
                          <h4 style={{ fontFamily: "times new roman" }}>
                            Earnings
                          </h4>
                        </u>
                      </b>
                    </h5>
                  </div>

                  <div class="col-md-60" id="fieldName">
                    <OFMSUI.Row>
                      <OFMSUI.Col
                        xs={12}
                        sm={12}
                        md={12}
                        lg={3}
                        xl={3}
                        xxl={3}
                        className=""
                      >
                        <th style={{ fontFamily: "roboto" }}> Basic Pay</th>

                        <Field
                          name="basic_pay_earnings"
                          onChange={(e) => {
                            formik.handleChange(e);
                          }}

                          type="text"
                          onKeyPress={(e) => NumberValidation(e)}
                          maxLength={15}
                          onPaste={(e) => {
                            const pastedData = e.clipboardData.getData("text");
                            if (!/^\d+$/.test(pastedData)) {
                              e.preventDefault();
                            }
                          }}
                          className={
                            formik.touched.basic_pay_earnings &&
                              formik.errors.basic_pay_earnings
                              ? "form-control is-invalid"
                              : "form-control"
                          }
                        />
                      </OFMSUI.Col>
                      <OFMSUI.Col
                        xs={12}
                        sm={12}
                        md={12}
                        lg={3}
                        xl={3}
                        xxl={3}
                        className=""
                      >
                        <th style={{ fontFamily: "roboto" }}> Personal Pay</th>

                        <Field
                          name="per_pay_earnings"
                          onChange={(e) => {
                            formik.handleChange(e);
                          }}
                          type="text"
                          onKeyPress={(e) => NumberValidation(e)}
                          maxLength={15}
                          onPaste={(e) => {
                            const pastedData = e.clipboardData.getData("text");
                            if (!/^\d+$/.test(pastedData)) {
                              e.preventDefault();
                            }
                          }}
                          className={
                            formik.touched.per_pay_earnings &&
                              formik.errors.per_pay_earnings
                              ? "form-control is-invalid"
                              : "form-control"
                          }
                        />
                      </OFMSUI.Col>
                      <OFMSUI.Col
                        xs={12}
                        sm={12}
                        md={12}
                        lg={3}
                        xl={3}
                        xxl={3}
                        className=""
                      >
                        <th style={{ fontFamily: "roboto" }}>Special Pay</th>

                        <Field
                          name="spl_pay_earnings"
                          onChange={(e) => {
                            formik.handleChange(e);
                          }}
                          type="text"
                          onKeyPress={(e) => NumberValidation(e)}
                          maxLength={15}
                          onPaste={(e) => {
                            const pastedData = e.clipboardData.getData("text");
                            if (!/^\d+$/.test(pastedData)) {
                              e.preventDefault();
                            }
                          }}
                          className={
                            formik.touched.spl_pay_earnings &&
                              formik.errors.spl_pay_earnings
                              ? "form-control is-invalid"
                              : "form-control"
                          }
                        />
                      </OFMSUI.Col>
                      <OFMSUI.Col
                        xs={12}
                        sm={12}
                        md={12}
                        lg={1}
                        xl={1}
                        xxl={1}
                        className=""
                      >
                        {" "}
                        <th style={{ fontFamily: "roboto" }}>
                          D.A. (Percentage)
                        </th>
                        <Field
                          name="da_earnings_per"
                          onChange={(e) => {
                            formik.handleChange(e);
                          }}
                          value={`${calculateDAPercentage()} `}
                          type="text"
                          onKeyPress={(e) => NumberValidation(e)}
                          maxLength={15}
                          onPaste={(e) => {
                            const pastedData = e.clipboardData.getData("text");
                            if (!/^\d+$/.test(pastedData)) {
                              e.preventDefault();
                            }
                          }}
                          className={
                            formik.touched.da_earnings_per &&
                              formik.errors.da_earnings_per
                              ? "form-control is-invalid"
                              : "form-control"
                          }
                        />
                      </OFMSUI.Col>
                      <OFMSUI.Col
                        xs={12}
                        sm={12}
                        md={12}
                        lg={2}
                        xl={2}
                        xxl={2}
                        className=""
                      >
                        {" "}
                        <th style={{ fontFamily: "roboto" }}>D.A.</th>
                        <Field
                          name="da_earnings"
                          onChange={(e) => {
                            formik.handleChange(e);
                          }}
                          type="text"
                          onKeyPress={(e) => NumberValidation(e)}
                          maxLength={15}
                          onPaste={(e) => {
                            const pastedData = e.clipboardData.getData("text");
                            if (!/^\d+$/.test(pastedData)) {
                              e.preventDefault();
                            }
                          }}
                          className={
                            formik.touched.da_earnings &&
                              formik.errors.da_earnings
                              ? "form-control is-invalid"
                              : "form-control"
                          }
                        />
                        <ErrorMessage
                          name="da_earnings"
                          component="div"
                          className="invalid-feedback"
                        />
                      </OFMSUI.Col>
                    </OFMSUI.Row>
                    <OFMSUI.Row> </OFMSUI.Row>
                    <OFMSUI.Row>
                      {" "}
                      <OFMSUI.Col
                        xs={12}
                        sm={12}
                        md={12}
                        lg={3}
                        xl={3}
                        xxl={3}
                        className=""
                      >
                        <th style={{ fontFamily: "roboto" }}>
                          {" "}
                          H.R.A (percentage)
                        </th>

                        <Field
                          name="hra_earnings_per"
                          onChange={(e) => {
                            formik.handleChange(e);
                          }}
                          type="text"
                          onKeyPress={(e) => NumberValidation(e)}
                          maxLength={15}
                          onPaste={(e) => {
                            const pastedData = e.clipboardData.getData("text");
                            if (!/^\d+$/.test(pastedData)) {
                              e.preventDefault();
                            }
                          }}
                          value={`${calculateHRAPercentage()} `}
                          className={
                            formik.touched.hra_earnings_per &&
                              formik.errors.hra_earnings_per
                              ? "form-control is-invalid"
                              : "form-control"
                          }
                        />
                      </OFMSUI.Col>
                      <OFMSUI.Col
                        xs={12}
                        sm={12}
                        md={12}
                        lg={3}
                        xl={3}
                        xxl={3}
                        className=""
                      >
                        <th style={{ fontFamily: "roboto" }}> H.R.A</th>

                        <Field
                          name="hra_earnings"
                          onChange={(e) => {
                            formik.handleChange(e);
                          }}
                          type="text"
                          onKeyPress={(e) => NumberValidation(e)}
                          maxLength={15}
                          onPaste={(e) => {
                            const pastedData = e.clipboardData.getData("text");
                            if (!/^\d+$/.test(pastedData)) {
                              e.preventDefault();
                            }
                          }}
                          className={
                            formik.touched.hra_earnings &&
                              formik.errors.hra_earnings
                              ? "form-control is-invalid"
                              : "form-control"
                          }
                        />
                        <ErrorMessage
                          name="hra_earnings"
                          component="div"
                          className="invalid-feedback"
                        />
                      </OFMSUI.Col>
                      <OFMSUI.Col
                        xs={12}
                        sm={12}
                        md={12}
                        lg={3}
                        xl={3}
                        xxl={3}
                        className=""
                      >
                        <th style={{ fontFamily: "roboto" }}> C.C.A</th>

                        <Field
                          name="cca_earnings"
                          onChange={(e) => {
                            formik.handleChange(e);
                          }}
                          type="text"
                          onKeyPress={(e) => NumberValidation(e)}
                          maxLength={15}
                          onPaste={(e) => {
                            const pastedData = e.clipboardData.getData("text");
                            if (!/^\d+$/.test(pastedData)) {
                              e.preventDefault();
                            }
                          }}
                          className={
                            formik.touched.cca_earnings &&
                              formik.errors.cca_earnings
                              ? "form-control is-invalid"
                              : "form-control"
                          }
                        />
                      </OFMSUI.Col>
                      <OFMSUI.Col
                        xs={12}
                        sm={12}
                        md={12}
                        lg={3}
                        xl={3}
                        xxl={3}
                        className=""
                      >
                        <th style={{ fontFamily: "roboto" }}> G.P</th>

                        <Field
                          name="gp_earnings"
                          className={
                            formik.touched.gp_earnings &&
                              formik.errors.gp_earnings
                              ? "form-control is-invalid"
                              : "form-control"
                          }
                          type="text"
                          onKeyPress={(e) => NumberValidation(e)}
                          maxLength={15}
                          onPaste={(e) => {
                            const pastedData = e.clipboardData.getData("text");
                            if (!/^\d+$/.test(pastedData)) {
                              e.preventDefault();
                            }
                          }}
                          onChange={(e) => {
                            formik.handleChange(e);
                          }}
                        />
                      </OFMSUI.Col>
                    </OFMSUI.Row>
                    <OFMSUI.Row>
                      <OFMSUI.Col
                        xs={12}
                        sm={12}
                        md={12}
                        lg={3}
                        xl={3}
                        xxl={3}
                        className=""
                      >
                        <th style={{ fontFamily: "roboto" }}>IR (percentage)</th>

                        <Field
                          name="ir_earnings_per"
                          className={
                            formik.touched.ir_earnings_per &&
                              formik.errors.ir_earnings_per
                              ? "form-control is-invalid"
                              : "form-control"
                          }
                          value={`${calculateIRPercentage()} `}
                          type="text"
                          onKeyPress={(e) => NumberValidation(e)}
                          maxLength={15}
                          onPaste={(e) => {
                            const pastedData = e.clipboardData.getData("text");
                            if (!/^\d+$/.test(pastedData)) {
                              e.preventDefault();
                            }
                          }}
                          onChange={(e) => {
                            formik.handleChange(e);
                          }}
                        />
                      </OFMSUI.Col>
                      <OFMSUI.Col
                        xs={12}
                        sm={12}
                        md={12}
                        lg={3}
                        xl={3}
                        xxl={3}
                        className=""
                      >
                        <th style={{ fontFamily: "roboto" }}>IR</th>

                        <Field
                          name="ir_earnings"
                          className={
                            formik.touched.ir_earnings &&
                              formik.errors.ir_earnings
                              ? "form-control is-invalid"
                              : "form-control"
                          }
                          type="text"
                          onChange={(e) => {
                            formik.handleChange(e);
                          }}
                          onKeyPress={(e) => NumberValidation(e)}
                          maxLength={15}
                          onPaste={(e) => {
                            const pastedData = e.clipboardData.getData("text");
                            if (!/^\d+$/.test(pastedData)) {
                              e.preventDefault();
                            }
                          }}

                        />

                        <ErrorMessage
                          name="ir_earnings"
                          component="div"
                          className="invalid-feedback"
                        />
                      </OFMSUI.Col>
                      <OFMSUI.Col
                        xs={12}
                        sm={12}
                        md={12}
                        lg={3}
                        xl={3}
                        xxl={3}
                        className=""
                      >
                        <th style={{ fontFamily: "roboto" }}> Medical</th>

                        <Field
                          name="medical_earnings"
                          className={
                            formik.touched.medical_earnings &&
                              formik.errors.medical_earnings
                              ? "form-control is-invalid"
                              : "form-control"
                          }
                          type="text"
                          onKeyPress={(e) => NumberValidation(e)}
                          maxLength={15}
                          onPaste={(e) => {
                            const pastedData = e.clipboardData.getData("text");
                            if (!/^\d+$/.test(pastedData)) {
                              e.preventDefault();
                            }
                          }}
                          onChange={(e) => {
                            formik.handleChange(e);
                          }}
                        />
                      </OFMSUI.Col>
                      <OFMSUI.Col
                        xs={12}
                        sm={12}
                        md={12}
                        lg={3}
                        xl={3}
                        xxl={3}
                        className=""
                      >
                        <th style={{ fontFamily: "roboto" }}>C.A</th>

                        <Field
                          name="ca_earnings"
                          className={
                            formik.touched.ca_earnings &&
                              formik.errors.ca_earnings
                              ? "form-control is-invalid"
                              : "form-control"
                          }
                          type="text"
                          onKeyPress={(e) => NumberValidation(e)}
                          maxLength={15}
                          onPaste={(e) => {
                            const pastedData = e.clipboardData.getData("text");
                            if (!/^\d+$/.test(pastedData)) {
                              e.preventDefault();
                            }
                          }}
                          onChange={(e) => {
                            formik.handleChange(e);
                          }}
                        />
                      </OFMSUI.Col>
                    </OFMSUI.Row>
                    <OFMSUI.Row>
                      {" "}
                      <OFMSUI.Col
                        xs={12}
                        sm={12}
                        md={12}
                        lg={3}
                        xl={3}
                        xxl={3}
                        className=""
                      >
                        <th style={{ fontFamily: "roboto" }}>
                          Special Allowance.
                        </th>

                        <Field
                          name="spl_all"
                          className={
                            formik.touched.spl_all && formik.errors.spl_all
                              ? "form-control is-invalid"
                              : "form-control"
                          }
                          type="text"
                          onKeyPress={(e) => NumberValidation(e)}
                          maxLength={15}
                          onPaste={(e) => {
                            const pastedData = e.clipboardData.getData("text");
                            if (!/^\d+$/.test(pastedData)) {
                              e.preventDefault();
                            }
                          }}
                          onChange={(e) => {
                            formik.handleChange(e);
                          }}
                        />
                      </OFMSUI.Col>
                      <OFMSUI.Col
                        xs={12}
                        sm={12}
                        md={12}
                        lg={3}
                        xl={3}
                        xxl={3}
                        className=""
                      >
                        <th style={{ fontFamily: "roboto" }}>Misc.(H.C)</th>

                        <Field
                          name="misc_h_c"
                          className={
                            formik.touched.misc_h_c && formik.errors.misc_h_c
                              ? "form-control is-invalid"
                              : "form-control"
                          }
                          type="text"
                          onKeyPress={(e) => NumberValidation(e)}
                          maxLength={15}
                          onPaste={(e) => {
                            const pastedData = e.clipboardData.getData("text");
                            if (!/^\d+$/.test(pastedData)) {
                              e.preventDefault();
                            }
                          }}
                          onChange={(e) => {
                            formik.handleChange(e);
                          }}
                        />
                      </OFMSUI.Col>
                      <OFMSUI.Col
                        xs={12}
                        sm={12}
                        md={12}
                        lg={3}
                        xl={3}
                        xxl={3}
                        className=""
                      >
                        <th style={{ fontFamily: "roboto" }}>
                          Addl. HRA(Tribal Area)
                        </th>

                        <Field
                          name="addl_hra"
                          className={
                            formik.touched.addl_hra && formik.errors.addl_hra
                              ? "form-control is-invalid"
                              : "form-control"
                          }
                          type="text"
                          onKeyPress={(e) => NumberValidation(e)}
                          maxLength={15}
                          onPaste={(e) => {
                            const pastedData = e.clipboardData.getData("text");
                            if (!/^\d+$/.test(pastedData)) {
                              e.preventDefault();
                            }
                          }}
                          onChange={(e) => {
                            formik.handleChange(e);
                          }}
                        />
                      </OFMSUI.Col>
                      <OFMSUI.Col
                        xs={12}
                        sm={12}
                        md={12}
                        lg={3}
                        xl={3}
                        xxl={3}
                        className=""
                      >
                        <th style={{ fontFamily: "roboto" }}>SCA(Tribal Area)</th>

                        <Field
                          name="sca"
                          className={
                            formik.touched.sca && formik.errors.sca
                              ? "form-control is-invalid"
                              : "form-control"
                          }
                          type="text"
                          onKeyPress={(e) => NumberValidation(e)}
                          maxLength={15}
                          onPaste={(e) => {
                            const pastedData = e.clipboardData.getData("text");
                            if (!/^\d+$/.test(pastedData)) {
                              e.preventDefault();
                            }
                          }}
                          onChange={(e) => {
                            formik.handleChange(e);
                          }}
                        />
                      </OFMSUI.Col>
                    </OFMSUI.Row>
                    <OFMSUI.Row>
                      <OFMSUI.Col
                        xs={12}
                        sm={12}
                        md={12}
                        lg={2}
                        xl={2}
                        xxl={2}
                        className=""
                      >
                        <th
                          style={{
                            fontFamily: "roboto",
                            color: "green",
                            fontWeight: "1000",
                          }}
                        >
                          <u>Total Earnings</u>
                        </th>

                        <Field
                          name="totalEarnings"
                          className={
                            formik.touched.totalEarnings &&
                              formik.errors.totalEarnings
                              ? "form-control is-invalid"
                              : "form-control"
                          }
                          type="text"
                          onKeyPress={(e) => NumberValidation(e)}
                          // maxLength={15}
                          value={fieldNames
                            .reduce(
                              (total, fieldName) =>
                                total + parseFloat(formik.values[fieldName] || 0),
                              0
                            )
                            .toLocaleString({
                              style: "currency",
                              currency: "INR",
                              maximumFractionDigits: 0,
                            })}
                          readOnly
                        />
                      </OFMSUI.Col>
                    </OFMSUI.Row>
                  </div>

                  <div style={{ textAlign: "left" }} id="deductionNames">
                    <h5 style={{ color: "#004687" }}>
                      <b style={{ color: "#0e6793" }}>
                        <u>
                          {" "}
                          <h4 style={{ fontFamily: "times new roman" }}>
                            Deductions
                          </h4>
                        </u>
                      </b>
                    </h5>
                  </div>
                  <div class="col-md-60">
                    <OFMSUI.Row>
                      <OFMSUI.Col
                        xs={12}
                        sm={12}
                        md={12}
                        lg={3}
                        xl={3}
                        xxl={3}
                        className=""
                      >
                        <th style={{ fontFamily: "roboto" }}>
                          GPF(Subscription)
                        </th>

                        <Field
                          name="gpfs_deductions"
                          type="text"
                          onKeyPress={(e) => NumberValidation(e)}
                          maxLength={15}
                          onPaste={(e) => {
                            const pastedData = e.clipboardData.getData("text");
                            if (!/^\d+$/.test(pastedData)) {
                              e.preventDefault();
                            }
                          }}
                          className={
                            formik.touched.gpfs_deductions &&
                              formik.errors.gpfs_deductions
                              ? "form-control is-invalid"
                              : "form-control"
                          }
                          onChange={formik.handleChange}
                        />
                      </OFMSUI.Col>
                      <OFMSUI.Col
                        xs={12}
                        sm={12}
                        md={12}
                        lg={3}
                        xl={3}
                        xxl={3}
                        className=""
                      >
                        <th style={{ fontFamily: "roboto" }}>
                          GPF(Addl. Subscription)
                        </th>

                        <Field
                          name="gpfsa_deductions"
                          type="text"
                          onKeyPress={(e) => NumberValidation(e)}
                          maxLength={15}
                          onPaste={(e) => {
                            const pastedData = e.clipboardData.getData("text");
                            if (!/^\d+$/.test(pastedData)) {
                              e.preventDefault();
                            }
                          }}
                          className={
                            formik.touched.gpfsa_deductions &&
                              formik.errors.gpfsa_deductions
                              ? "form-control is-invalid"
                              : "form-control"
                          }
                        />
                      </OFMSUI.Col>
                      <OFMSUI.Col
                        xs={12}
                        sm={12}
                        md={12}
                        lg={3}
                        xl={3}
                        xxl={3}
                        className=""
                      >
                        <th style={{ fontFamily: "roboto" }}>GPF(Loan)</th>

                        <Field
                          name="gpfl_deductions"
                          type="text"
                          onKeyPress={(e) => NumberValidation(e)}
                          maxLength={15}
                          onPaste={(e) => {
                            const pastedData = e.clipboardData.getData("text");
                            if (!/^\d+$/.test(pastedData)) {
                              e.preventDefault();
                            }
                          }}
                          className={
                            formik.touched.gpfl_deductions &&
                              formik.errors.gpfl_deductions
                              ? "form-control is-invalid"
                              : "form-control"
                          }
                        />
                      </OFMSUI.Col>
                      <OFMSUI.Col
                        xs={12}
                        sm={12}
                        md={12}
                        lg={3}
                        xl={3}
                        xxl={3}
                        className=""
                      >
                        {" "}
                        <th style={{ fontFamily: "roboto" }}>
                          APGLI(Subscription)
                        </th>
                        <Field
                          name="apglis_deductions"
                          type="text"
                          onKeyPress={(e) => NumberValidation(e)}
                          maxLength={15}
                          onPaste={(e) => {
                            const pastedData = e.clipboardData.getData("text");
                            if (!/^\d+$/.test(pastedData)) {
                              e.preventDefault();
                            }
                          }}
                          className={
                            formik.touched.apglis_deductions &&
                              formik.errors.apglis_deductions
                              ? "form-control is-invalid"
                              : "form-control"
                          }
                        />
                      </OFMSUI.Col>
                    </OFMSUI.Row>
                    <OFMSUI.Row>
                      {" "}
                      <OFMSUI.Col
                        xs={12}
                        sm={12}
                        md={12}
                        lg={3}
                        xl={3}
                        xxl={3}
                        className=""
                      >
                        {" "}
                        <th style={{ fontFamily: "roboto" }}>APGLI(Loan)</th>
                        <Field
                          name="apglil_deductions"
                          type="text"
                          onKeyPress={(e) => NumberValidation(e)}
                          maxLength={15}
                          onPaste={(e) => {
                            const pastedData = e.clipboardData.getData("text");
                            if (!/^\d+$/.test(pastedData)) {
                              e.preventDefault();
                            }
                          }}
                          className={
                            formik.touched.apglil_deductions &&
                              formik.errors.apglil_deductions
                              ? "form-control is-invalid"
                              : "form-control"
                          }
                        />
                      </OFMSUI.Col>
                      <OFMSUI.Col
                        xs={12}
                        sm={12}
                        md={12}
                        lg={3}
                        xl={3}
                        xxl={3}
                        className=""
                      >
                        <th style={{ fontFamily: "roboto" }}>GIS</th>

                        <Field
                          name="gis_deductions"
                          type="text"
                          onKeyPress={(e) => NumberValidation(e)}
                          maxLength={15}
                          onPaste={(e) => {
                            const pastedData = e.clipboardData.getData("text");
                            if (!/^\d+$/.test(pastedData)) {
                              e.preventDefault();
                            }
                          }}
                          className={
                            formik.touched.gis_deductions &&
                              formik.errors.gis_deductions
                              ? "form-control is-invalid"
                              : "form-control"
                          }
                        />
                      </OFMSUI.Col>
                      <OFMSUI.Col
                        xs={12}
                        sm={12}
                        md={12}
                        lg={3}
                        xl={3}
                        xxl={3}
                        className=""
                      >
                        <th style={{ fontFamily: "roboto" }}>
                          LIC(Subscription)
                        </th>

                        <Field
                          name="lic_deductions"
                          type="text"
                          onKeyPress={(e) => NumberValidation(e)}
                          maxLength={15}
                          onPaste={(e) => {
                            const pastedData = e.clipboardData.getData("text");
                            if (!/^\d+$/.test(pastedData)) {
                              e.preventDefault();
                            }
                          }}
                          className={
                            formik.touched.lic_deductions &&
                              formik.errors.lic_deductions
                              ? "form-control is-invalid"
                              : "form-control"
                          }
                        />
                      </OFMSUI.Col>
                      <OFMSUI.Col
                        xs={12}
                        sm={12}
                        md={12}
                        lg={3}
                        xl={3}
                        xxl={3}
                        className=""
                      >
                        <th style={{ fontFamily: "roboto" }}>License Fee</th>

                        <Field
                          name="license_deductions"
                          className={
                            formik.touched.license_deductions &&
                              formik.errors.license_deductions
                              ? "form-control is-invalid"
                              : "form-control"
                          }
                          type="text"
                          onKeyPress={(e) => NumberValidation(e)}
                          maxLength={15}
                          onPaste={(e) => {
                            const pastedData = e.clipboardData.getData("text");
                            if (!/^\d+$/.test(pastedData)) {
                              e.preventDefault();
                            }
                          }}
                          onChange={(e) => {
                            formik.handleChange(e);
                          }}
                        />
                      </OFMSUI.Col>
                    </OFMSUI.Row>
                    <OFMSUI.Row>
                      {" "}
                      <OFMSUI.Col
                        xs={12}
                        sm={12}
                        md={12}
                        lg={3}
                        xl={3}
                        xxl={3}
                        className=""
                      >
                        <th style={{ fontFamily: "roboto" }}>Con.Ded</th>

                        <Field
                          name="con_decd_deductions"
                          className={
                            formik.touched.con_decd_deductions &&
                              formik.errors.con_decd_deductions
                              ? "form-control is-invalid"
                              : "form-control"
                          }
                          type="text"
                          onKeyPress={(e) => NumberValidation(e)}
                          maxLength={15}
                          onPaste={(e) => {
                            const pastedData = e.clipboardData.getData("text");
                            if (!/^\d+$/.test(pastedData)) {
                              e.preventDefault();
                            }
                          }}
                          onChange={(e) => {
                            formik.handleChange(e);
                          }}
                        />
                      </OFMSUI.Col>
                      <OFMSUI.Col
                        xs={12}
                        sm={12}
                        md={12}
                        lg={3}
                        xl={3}
                        xxl={3}
                        className=""
                      >
                        <th style={{ fontFamily: "roboto" }}>EPF (percentage)</th>

                        <Field
                          name="epf_deductions_per"
                          className={
                            formik.touched.epf_deductions_per &&
                              formik.errors.epf_deductions_per
                              ? "form-control is-invalid"
                              : "form-control"
                          }
                          value={`${calculateEPFPercentage()} `}
                          type="text"
                          onKeyPress={(e) => NumberValidation(e)}
                          maxLength={15}
                          onPaste={(e) => {
                            const pastedData = e.clipboardData.getData("text");
                            if (!/^\d+$/.test(pastedData)) {
                              e.preventDefault();
                            }
                          }}
                          onChange={(e) => {
                            formik.handleChange(e);
                          }}
                        />
                      </OFMSUI.Col>
                      <OFMSUI.Col
                        xs={12}
                        sm={12}
                        md={12}
                        lg={3}
                        xl={3}
                        xxl={3}
                        className=""
                      >
                        <th style={{ fontFamily: "roboto" }}>EPF</th>

                        <Field
                          name="epf_deductions"
                          className={
                            formik.touched.epf_deductions &&
                              formik.errors.epf_deductions
                              ? "form-control is-invalid"
                              : "form-control"
                          }
                          type="text"
                          onKeyPress={(e) => NumberValidation(e)}
                          maxLength={15}
                          onPaste={(e) => {
                            const pastedData = e.clipboardData.getData("text");
                            if (!/^\d+$/.test(pastedData)) {
                              e.preventDefault();
                            }
                          }}
                          onChange={(e) => {
                            formik.handleChange(e);
                          }}
                        />
                      </OFMSUI.Col>
                      <OFMSUI.Col
                        xs={12}
                        sm={12}
                        md={12}
                        lg={3}
                        xl={3}
                        xxl={3}
                        className=""
                      >
                        <th style={{ fontFamily: "roboto" }}> EPF Loan</th>

                        <Field
                          name="epf_l_deductions"
                          className={
                            formik.touched.epf_l_deductions &&
                              formik.errors.epf_l_deductions
                              ? "form-control is-invalid"
                              : "form-control"
                          }
                          type="text"
                          onKeyPress={(e) => NumberValidation(e)}
                          maxLength={15}
                          onPaste={(e) => {
                            const pastedData = e.clipboardData.getData("text");
                            if (!/^\d+$/.test(pastedData)) {
                              e.preventDefault();
                            }
                          }}
                          onChange={(e) => {
                            formik.handleChange(e);
                          }}
                        />
                      </OFMSUI.Col>
                    </OFMSUI.Row>
                    <OFMSUI.Row>
                      <OFMSUI.Col
                        xs={12}
                        sm={12}
                        md={12}
                        lg={3}
                        xl={3}
                        xxl={3}
                        className=""
                      >
                        <th style={{ fontFamily: "roboto" }}>Voluntary PF</th>

                        <Field
                          name="vpf_deductions"
                          className={
                            formik.touched.vpf_deductions &&
                              formik.errors.vpf_deductions
                              ? "form-control is-invalid"
                              : "form-control"
                          }
                          type="text"
                          onKeyPress={(e) => NumberValidation(e)}
                          maxLength={15}
                          onPaste={(e) => {
                            const pastedData = e.clipboardData.getData("text");
                            if (!/^\d+$/.test(pastedData)) {
                              e.preventDefault();
                            }
                          }}
                          onChange={(e) => {
                            formik.handleChange(e);
                          }}
                        />
                      </OFMSUI.Col>
                      <OFMSUI.Col
                        xs={12}
                        sm={12}
                        md={12}
                        lg={3}
                        xl={3}
                        xxl={3}
                        className=""
                      >
                        <th style={{ fontFamily: "roboto" }}>PPF</th>

                        <Field
                          name="ppf_deductions"
                          className={
                            formik.touched.ppf_deductions &&
                              formik.errors.ppf_deductions
                              ? "form-control is-invalid"
                              : "form-control"
                          }
                          type="text"
                          onKeyPress={(e) => NumberValidation(e)}
                          maxLength={15}
                          onPaste={(e) => {
                            const pastedData = e.clipboardData.getData("text");
                            if (!/^\d+$/.test(pastedData)) {
                              e.preventDefault();
                            }
                          }}
                          onChange={(e) => {
                            formik.handleChange(e);
                          }}
                        />
                      </OFMSUI.Col>
                      <OFMSUI.Col
                        xs={12}
                        sm={12}
                        md={12}
                        lg={3}
                        xl={3}
                        xxl={3}
                        className=""
                      >
                        <th style={{ fontFamily: "roboto" }}> RCS Cont</th>

                        <Field
                          name="rcs_cont_deductions"
                          className={
                            formik.touched.rcs_cont_deductions &&
                              formik.errors.rcs_cont_deductions
                              ? "form-control is-invalid"
                              : "form-control"
                          }
                          type="text"
                          onKeyPress={(e) => NumberValidation(e)}
                          maxLength={15}
                          onPaste={(e) => {
                            const pastedData = e.clipboardData.getData("text");
                            if (!/^\d+$/.test(pastedData)) {
                              e.preventDefault();
                            }
                          }}
                          onChange={(e) => {
                            formik.handleChange(e);
                          }}
                        />
                      </OFMSUI.Col>
                      <OFMSUI.Col
                        xs={12}
                        sm={12}
                        md={12}
                        lg={3}
                        xl={3}
                        xxl={3}
                        className=""
                      >
                        <th style={{ fontFamily: "roboto" }}>CM's RF</th>

                        <Field
                          name="cmrf_deductions"
                          className={
                            formik.touched.cmrf_deductions &&
                              formik.errors.cmrf_deductions
                              ? "form-control is-invalid"
                              : "form-control"
                          }
                          type="text"
                          onKeyPress={(e) => NumberValidation(e)}
                          maxLength={15}
                          onPaste={(e) => {
                            const pastedData = e.clipboardData.getData("text");
                            if (!/^\d+$/.test(pastedData)) {
                              e.preventDefault();
                            }
                          }}
                          onChange={(e) => {
                            formik.handleChange(e);
                          }}
                        />
                      </OFMSUI.Col>
                    </OFMSUI.Row>

                    <OFMSUI.Row>
                      <OFMSUI.Col
                        xs={12}
                        sm={12}
                        md={12}
                        lg={3}
                        xl={3}
                        xxl={3}
                        className=""
                      >
                        <th style={{ fontFamily: "roboto" }}>FCF</th>

                        <Field
                          name="fcf_deductions"
                          className={
                            formik.touched.fcf_deductions &&
                              formik.errors.fcf_deductions
                              ? "form-control is-invalid"
                              : "form-control"
                          }
                          type="text"
                          onKeyPress={(e) => NumberValidation(e)}
                          maxLength={15}
                          onPaste={(e) => {
                            const pastedData = e.clipboardData.getData("text");
                            if (!/^\d+$/.test(pastedData)) {
                              e.preventDefault();
                            }
                          }}
                          onChange={(e) => {
                            formik.handleChange(e);
                          }}
                        />
                      </OFMSUI.Col>
                      <OFMSUI.Col
                        xs={12}
                        sm={12}
                        md={12}
                        lg={3}
                        xl={3}
                        xxl={3}
                        className=""
                      >
                        <th style={{ fontFamily: "roboto" }}> House Rent</th>

                        <Field
                          name="house_rent_deductions"
                          className={
                            formik.touched.house_rent_deductions &&
                              formik.errors.house_rent_deductions
                              ? "form-control is-invalid"
                              : "form-control"
                          }
                          type="text"
                          onKeyPress={(e) => NumberValidation(e)}
                          maxLength={15}
                          onPaste={(e) => {
                            const pastedData = e.clipboardData.getData("text");
                            if (!/^\d+$/.test(pastedData)) {
                              e.preventDefault();
                            }
                          }}
                          onChange={(e) => {
                            formik.handleChange(e);
                          }}
                        />
                      </OFMSUI.Col>
                      <OFMSUI.Col
                        xs={12}
                        sm={12}
                        md={12}
                        lg={3}
                        xl={3}
                        xxl={3}
                        className=""
                      >
                        <th style={{ fontFamily: "roboto" }}>Sal.Rec</th>

                        <Field
                          name="sal_rec_deductions"
                          className={
                            formik.touched.sal_rec_deductions &&
                              formik.errors.sal_rec_deductions
                              ? "form-control is-invalid"
                              : "form-control"
                          }
                          type="text"
                          onKeyPress={(e) => NumberValidation(e)}
                          maxLength={15}
                          onPaste={(e) => {
                            const pastedData = e.clipboardData.getData("text");
                            if (!/^\d+$/.test(pastedData)) {
                              e.preventDefault();
                            }
                          }}
                          onChange={(e) => {
                            formik.handleChange(e);
                          }}
                        />
                      </OFMSUI.Col>
                      <OFMSUI.Col
                        xs={12}
                        sm={12}
                        md={12}
                        lg={3}
                        xl={3}
                        xxl={3}
                        className=""
                      >
                        <th style={{ fontFamily: "roboto" }}>P.T</th>

                        <Field
                          name="pt_deductions"
                          className={
                            formik.touched.pt_deductions &&
                              formik.errors.pt_deductions
                              ? "form-control is-invalid"
                              : "form-control"
                          }
                          type="text"
                          onKeyPress={(e) => NumberValidation(e)}
                          maxLength={15}
                          onPaste={(e) => {
                            const pastedData = e.clipboardData.getData("text");
                            if (!/^\d+$/.test(pastedData)) {
                              e.preventDefault();
                            }
                          }}
                          onChange={(e) => {
                            formik.handleChange(e);
                          }}
                        />
                      </OFMSUI.Col>
                    </OFMSUI.Row>

                    <OFMSUI.Row>
                      <OFMSUI.Col
                        xs={12}
                        sm={12}
                        md={12}
                        lg={3}
                        xl={3}
                        xxl={3}
                        className=""
                      >
                        <th style={{ fontFamily: "roboto" }}>I.T.</th>

                        <Field
                          name="it_deductions"
                          className={
                            formik.touched.it_deductions &&
                              formik.errors.it_deductions
                              ? "form-control is-invalid"
                              : "form-control"
                          }
                          type="text"
                          onKeyPress={(e) => NumberValidation(e)}
                          maxLength={15}
                          onPaste={(e) => {
                            const pastedData = e.clipboardData.getData("text");
                            if (!/^\d+$/.test(pastedData)) {
                              e.preventDefault();
                            }
                          }}
                          onChange={(e) => {
                            formik.handleChange(e);
                          }}
                        />
                      </OFMSUI.Col>
                      {/* <OFMSUI.Col
                      xs={12}
                      sm={12}
                      md={12}
                      lg={3}
                      xl={3}
                      xxl={3}
                      className=""
                    >
                      <th style={{ fontFamily: "roboto" }}>Postal RD</th>

                      <Field
                        name="postal_deductions"
                        className={
                          formik.touched.postal_deductions && formik.errors.postal_deductions
                            ? "form-control is-invalid"
                            : "form-control"
                        }
                        type="text" onKeyPress={(e) => NumberValidation(e)}
                        maxLength={15}

                        onChange={(e) => {
                          formik.handleChange(e);
                        }}
                      />
                    </OFMSUI.Col> */}
                      <OFMSUI.Col
                        xs={12}
                        sm={12}
                        md={12}
                        lg={3}
                        xl={3}
                        xxl={3}
                        className=""
                      >
                        <th style={{ fontFamily: "roboto" }}>
                          Other Liabilities
                        </th>

                        <Field
                          name="other_deductions"
                          className={
                            formik.touched.other_deductions &&
                              formik.errors.other_deductions
                              ? "form-control is-invalid"
                              : "form-control"
                          }
                          type="text"
                          onKeyPress={(e) => NumberValidation(e)}
                          maxLength={15}
                          onPaste={(e) => {
                            const pastedData = e.clipboardData.getData("text");
                            if (!/^\d+$/.test(pastedData)) {
                              e.preventDefault();
                            }
                          }}
                          onChange={(e) => {
                            formik.handleChange(e);
                          }}
                        />
                      </OFMSUI.Col>
                      <OFMSUI.Col
                        xs={12}
                        sm={12}
                        md={12}
                        lg={2}
                        xl={2}
                        xxl={2}
                        className=""
                      >
                        <th
                          style={{
                            fontFamily: "roboto",
                            color: "red",
                            fontWeight: "1000",
                          }}
                        >
                          <u>Total Deductions</u>
                        </th>

                        <Field
                          name="totalDeductions"
                          className={
                            formik.touched.totalDeductions &&
                              formik.errors.totalDeductions
                              ? "form-control is-invalid"
                              : "form-control"
                          }
                          type="text"
                          onKeyPress={(e) => NumberValidation(e)}
                          value={deductionNames
                            .reduce(
                              (total, deductionNames) =>
                                total +
                                parseFloat(formik.values[deductionNames] || 0),
                              0
                            )
                            .toLocaleString({
                              style: "currency",
                              currency: "INR",
                              maximumFractionDigits: 0,
                            })}
                          readOnly
                        />
                      </OFMSUI.Col>
                    </OFMSUI.Row>
                  </div>
                  <div style={{ textAlign: "left" }} id="LoanDeductions">
                    <h5 style={{ color: "#004687" }}>
                      <b style={{ color: "#0e6793" }}>
                        <u>
                          {" "}
                          <h4 style={{ fontFamily: "times new roman" }}>
                            Loan Advances
                          </h4>
                        </u>
                      </b>
                    </h5>
                  </div>
                  <Table striped bordered hover id="my-table">
                    <thead className="fw-bold">
                      <tr style={{ backgroundColor: "lightblue" }}>
                        <th style={{ width: "150px" }}></th>
                        <th>
                          <h6>P I </h6>
                        </th>
                        <th>
                          <h6>T I </h6>
                        </th>
                        <th>
                          <h6>AMOUNT</h6>
                        </th>
                        <th style={{ width: "150px" }}></th>
                        <th>
                          <h6>P I </h6>
                        </th>
                        <th>
                          <h6>T I </h6>
                        </th>
                        <th>
                          <h6>AMOUNT</h6>
                        </th>
                      </tr>
                    </thead>
                    <tbody style={{ backgroundColor: "whitesmoke" }}>
                      <tr>
                        {" "}
                        <td
                          style={{
                            color: "black",
                            backgroundColor: "white",
                            fontWeight: "700",
                            fontFamily: "roboto",
                          }}
                        >
                          CAR-Principal
                        </td>
                        <td>
                          <Field
                            name="car_a_loanpi"
                            onChange={(e) => {
                              formik.handleChange(e);
                            }}
                            type="text"
                            onKeyPress={(e) => NumberValidation(e)}
                            maxLength={15}
                            onPaste={(e) => {
                              const pastedData = e.clipboardData.getData("text");
                              if (!/^\d+$/.test(pastedData)) {
                                e.preventDefault();
                              }
                            }}
                            className={
                              formik.touched.car_a_loanpi &&
                                formik.errors.car_a_loanpi
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                          />
                        </td>
                        <td>
                          <Field
                            name="car_a_loanti"
                            onChange={(e) => {
                              formik.handleChange(e);
                            }}
                            type="text"
                            onKeyPress={(e) => NumberValidation(e)}
                            maxLength={15}
                            onPaste={(e) => {
                              const pastedData = e.clipboardData.getData("text");
                              if (!/^\d+$/.test(pastedData)) {
                                e.preventDefault();
                              }
                            }}
                            className={
                              formik.touched.car_a_loanti &&
                                formik.errors.car_a_loanti
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                          />
                        </td>
                        <td>
                          <Field
                            name="car_a_loan"
                            onChange={(e) => {
                              formik.handleChange(e);
                            }}
                            type="text"
                            onKeyPress={(e) => NumberValidation(e)}
                            maxLength={15}
                            onPaste={(e) => {
                              const pastedData = e.clipboardData.getData("text");
                              if (!/^\d+$/.test(pastedData)) {
                                e.preventDefault();
                              }
                            }}
                            className={
                              formik.touched.car_a_loan &&
                                formik.errors.car_a_loan
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                          />
                        </td>
                        <td
                          style={{
                            color: "black",
                            backgroundColor: "white",
                            fontWeight: "700",
                            fontFamily: "roboto",
                          }}
                        >
                          CAR-Interest
                        </td>
                        <td>
                          <Field
                            name="car_i_loanpi"
                            onChange={(e) => {
                              formik.handleChange(e);
                            }}
                            type="text"
                            onKeyPress={(e) => NumberValidation(e)}
                            maxLength={15}
                            onPaste={(e) => {
                              const pastedData = e.clipboardData.getData("text");
                              if (!/^\d+$/.test(pastedData)) {
                                e.preventDefault();
                              }
                            }}
                            className={
                              formik.touched.car_i_loanpi &&
                                formik.errors.car_i_loanpi
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                          />
                        </td>
                        <td>
                          <Field
                            name="car_i_loanti"
                            onChange={(e) => {
                              formik.handleChange(e);
                            }}
                            type="text"
                            onKeyPress={(e) => NumberValidation(e)}
                            maxLength={15}
                            onPaste={(e) => {
                              const pastedData = e.clipboardData.getData("text");
                              if (!/^\d+$/.test(pastedData)) {
                                e.preventDefault();
                              }
                            }}
                            className={
                              formik.touched.car_i_loanti &&
                                formik.errors.car_i_loanti
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                          />
                        </td>
                        <td>
                          <Field
                            name="car_i_loan"
                            onChange={(e) => {
                              formik.handleChange(e);
                            }}
                            type="text"
                            onKeyPress={(e) => NumberValidation(e)}
                            maxLength={15}
                            onPaste={(e) => {
                              const pastedData = e.clipboardData.getData("text");
                              if (!/^\d+$/.test(pastedData)) {
                                e.preventDefault();
                              }
                            }}
                            className={
                              formik.touched.car_i_loan &&
                                formik.errors.car_i_loan
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                          />
                        </td>
                      </tr>
                      <tr>
                        {" "}
                        <td
                          style={{
                            color: "black",
                            backgroundColor: "white",
                            fontWeight: "700",
                            fontFamily: "roboto",
                          }}
                        >
                          Cycle-Principal
                        </td>
                        <td>
                          <Field
                            name="cyc_a_loanpi"
                            onChange={(e) => {
                              formik.handleChange(e);
                            }}
                            type="text"
                            onKeyPress={(e) => NumberValidation(e)}
                            maxLength={15}
                            onPaste={(e) => {
                              const pastedData = e.clipboardData.getData("text");
                              if (!/^\d+$/.test(pastedData)) {
                                e.preventDefault();
                              }
                            }}
                            className={
                              formik.touched.cyc_a_loanpi &&
                                formik.errors.cyc_a_loanpi
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                          />
                        </td>
                        <td>
                          <Field
                            name="cyc_a_loanti"
                            onChange={(e) => {
                              formik.handleChange(e);
                            }}
                            type="text"
                            onKeyPress={(e) => NumberValidation(e)}
                            maxLength={15}
                            onPaste={(e) => {
                              const pastedData = e.clipboardData.getData("text");
                              if (!/^\d+$/.test(pastedData)) {
                                e.preventDefault();
                              }
                            }}
                            className={
                              formik.touched.cyc_a_loanti &&
                                formik.errors.cyc_a_loanti
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                          />
                        </td>
                        <td>
                          <Field
                            name="cyc_a_loan"
                            onChange={(e) => {
                              formik.handleChange(e);
                            }}
                            type="text"
                            onKeyPress={(e) => NumberValidation(e)}
                            maxLength={15}
                            onPaste={(e) => {
                              const pastedData = e.clipboardData.getData("text");
                              if (!/^\d+$/.test(pastedData)) {
                                e.preventDefault();
                              }
                            }}
                            className={
                              formik.touched.cyc_a_loan &&
                                formik.errors.cyc_a_loan
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                          />
                        </td>
                        <td
                          style={{
                            color: "black",
                            backgroundColor: "white",
                            fontWeight: "700",
                            fontFamily: "roboto",
                          }}
                        >
                          Cycle-Interest
                        </td>
                        <td>
                          <Field
                            name="cyc_i_loanpi"
                            onChange={(e) => {
                              formik.handleChange(e);
                            }}
                            type="text"
                            onKeyPress={(e) => NumberValidation(e)}
                            maxLength={15}
                            onPaste={(e) => {
                              const pastedData = e.clipboardData.getData("text");
                              if (!/^\d+$/.test(pastedData)) {
                                e.preventDefault();
                              }
                            }}
                            className={
                              formik.touched.cyc_i_loanpi &&
                                formik.errors.cyc_i_loanpi
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                          />
                        </td>
                        <td>
                          <Field
                            name="cyc_i_loanti"
                            onChange={(e) => {
                              formik.handleChange(e);
                            }}
                            type="text"
                            onKeyPress={(e) => NumberValidation(e)}
                            maxLength={15}
                            onPaste={(e) => {
                              const pastedData = e.clipboardData.getData("text");
                              if (!/^\d+$/.test(pastedData)) {
                                e.preventDefault();
                              }
                            }}
                            className={
                              formik.touched.cyc_i_loanti &&
                                formik.errors.cyc_i_loanti
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                          />
                        </td>
                        <td>
                          <Field
                            name="cyc_i_loan"
                            onChange={(e) => {
                              formik.handleChange(e);
                            }}
                            type="text"
                            onKeyPress={(e) => NumberValidation(e)}
                            maxLength={15}
                            onPaste={(e) => {
                              const pastedData = e.clipboardData.getData("text");
                              if (!/^\d+$/.test(pastedData)) {
                                e.preventDefault();
                              }
                            }}
                            className={
                              formik.touched.cyc_i_loan &&
                                formik.errors.cyc_i_loan
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                          />
                        </td>
                      </tr>
                      <tr>
                        {" "}
                        <td
                          style={{
                            color: "black",
                            backgroundColor: "white",
                            fontWeight: "700",
                            fontFamily: "roboto",
                          }}
                        >
                          MCA-Principal
                        </td>
                        <td>
                          <Field
                            name="mca_a_loanpi"
                            onChange={(e) => {
                              formik.handleChange(e);
                            }}
                            type="text"
                            onKeyPress={(e) => NumberValidation(e)}
                            maxLength={15}
                            onPaste={(e) => {
                              const pastedData = e.clipboardData.getData("text");
                              if (!/^\d+$/.test(pastedData)) {
                                e.preventDefault();
                              }
                            }}
                            className={
                              formik.touched.mca_a_loanpi &&
                                formik.errors.mca_a_loanpi
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                          />
                        </td>
                        <td>
                          <Field
                            name="mca_a_loanti"
                            onChange={(e) => {
                              formik.handleChange(e);
                            }}
                            type="text"
                            onKeyPress={(e) => NumberValidation(e)}
                            maxLength={15}
                            onPaste={(e) => {
                              const pastedData = e.clipboardData.getData("text");
                              if (!/^\d+$/.test(pastedData)) {
                                e.preventDefault();
                              }
                            }}
                            className={
                              formik.touched.mca_a_loanti &&
                                formik.errors.mca_a_loanti
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                          />
                        </td>
                        <td>
                          <Field
                            name="mca_a_loan"
                            onChange={(e) => {
                              formik.handleChange(e);
                            }}
                            type="text"
                            onKeyPress={(e) => NumberValidation(e)}
                            maxLength={15}
                            onPaste={(e) => {
                              const pastedData = e.clipboardData.getData("text");
                              if (!/^\d+$/.test(pastedData)) {
                                e.preventDefault();
                              }
                            }}
                            className={
                              formik.touched.mca_a_loan &&
                                formik.errors.mca_a_loan
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                          />
                        </td>
                        <td
                          style={{
                            color: "black",
                            backgroundColor: "white",
                            fontWeight: "700",
                            fontFamily: "roboto",
                          }}
                        >
                          MCA-Interest
                        </td>
                        <td>
                          <Field
                            name="mca_i_loanpi"
                            onChange={(e) => {
                              formik.handleChange(e);
                            }}
                            type="text"
                            onKeyPress={(e) => NumberValidation(e)}
                            maxLength={15}
                            onPaste={(e) => {
                              const pastedData = e.clipboardData.getData("text");
                              if (!/^\d+$/.test(pastedData)) {
                                e.preventDefault();
                              }
                            }}
                            className={
                              formik.touched.mca_i_loanpi &&
                                formik.errors.mca_i_loanpi
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                          />
                        </td>
                        <td>
                          <Field
                            name="mca_i_loanti"
                            onChange={(e) => {
                              formik.handleChange(e);
                            }}
                            type="text"
                            onKeyPress={(e) => NumberValidation(e)}
                            maxLength={15}
                            onPaste={(e) => {
                              const pastedData = e.clipboardData.getData("text");
                              if (!/^\d+$/.test(pastedData)) {
                                e.preventDefault();
                              }
                            }}
                            className={
                              formik.touched.mca_i_loanti &&
                                formik.errors.mca_i_loanti
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                          />
                        </td>
                        <td>
                          <Field
                            name="mca_i_loan"
                            onChange={(e) => {
                              formik.handleChange(e);
                            }}
                            type="text"
                            onKeyPress={(e) => NumberValidation(e)}
                            maxLength={15}
                            onPaste={(e) => {
                              const pastedData = e.clipboardData.getData("text");
                              if (!/^\d+$/.test(pastedData)) {
                                e.preventDefault();
                              }
                            }}
                            className={
                              formik.touched.mca_i_loan &&
                                formik.errors.mca_i_loan
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                          />
                        </td>
                      </tr>

                      <tr>
                        {" "}
                        <td
                          style={{
                            color: "black",
                            backgroundColor: "white",
                            fontWeight: "700",
                            fontFamily: "roboto",
                          }}
                        >
                          MAR-Principal
                        </td>
                        <td>
                          <Field
                            name="mar_a_loanpi"
                            onChange={(e) => {
                              formik.handleChange(e);
                            }}
                            type="text"
                            onKeyPress={(e) => NumberValidation(e)}
                            maxLength={15}
                            onPaste={(e) => {
                              const pastedData = e.clipboardData.getData("text");
                              if (!/^\d+$/.test(pastedData)) {
                                e.preventDefault();
                              }
                            }}
                            className={
                              formik.touched.mar_a_loanpi &&
                                formik.errors.mar_a_loanpi
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                          />
                        </td>
                        <td>
                          <Field
                            name="mar_a_loanti"
                            onChange={(e) => {
                              formik.handleChange(e);
                            }}
                            type="text"
                            onKeyPress={(e) => NumberValidation(e)}
                            maxLength={15}
                            onPaste={(e) => {
                              const pastedData = e.clipboardData.getData("text");
                              if (!/^\d+$/.test(pastedData)) {
                                e.preventDefault();
                              }
                            }}
                            className={
                              formik.touched.mar_a_loanti &&
                                formik.errors.mar_a_loanti
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                          />
                        </td>
                        <td>
                          <Field
                            name="mar_a_loan"
                            onChange={(e) => {
                              formik.handleChange(e);
                            }}
                            type="text"
                            onKeyPress={(e) => NumberValidation(e)}
                            maxLength={15}
                            onPaste={(e) => {
                              const pastedData = e.clipboardData.getData("text");
                              if (!/^\d+$/.test(pastedData)) {
                                e.preventDefault();
                              }
                            }}
                            className={
                              formik.touched.mar_a_loan &&
                                formik.errors.mar_a_loan
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                          />
                        </td>
                        <td
                          style={{
                            color: "black",
                            backgroundColor: "white",
                            fontWeight: "700",
                            fontFamily: "roboto",
                          }}
                        >
                          MAR-Interest
                        </td>
                        <td>
                          <Field
                            name="mar_i_loanpi"
                            onChange={(e) => {
                              formik.handleChange(e);
                            }}
                            type="text"
                            onKeyPress={(e) => NumberValidation(e)}
                            maxLength={15}
                            onPaste={(e) => {
                              const pastedData = e.clipboardData.getData("text");
                              if (!/^\d+$/.test(pastedData)) {
                                e.preventDefault();
                              }
                            }}
                            className={
                              formik.touched.mar_i_loanpi &&
                                formik.errors.mar_i_loanpi
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                          />
                        </td>
                        <td>
                          <Field
                            name="mar_i_loanti"
                            onChange={(e) => {
                              formik.handleChange(e);
                            }}
                            type="text"
                            onKeyPress={(e) => NumberValidation(e)}
                            maxLength={15}
                            onPaste={(e) => {
                              const pastedData = e.clipboardData.getData("text");
                              if (!/^\d+$/.test(pastedData)) {
                                e.preventDefault();
                              }
                            }}
                            className={
                              formik.touched.mar_i_loanti &&
                                formik.errors.mar_i_loanti
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                          />
                        </td>
                        <td>
                          <Field
                            name="mar_i_loan"
                            onChange={(e) => {
                              formik.handleChange(e);
                            }}
                            type="text"
                            onKeyPress={(e) => NumberValidation(e)}
                            maxLength={15}
                            onPaste={(e) => {
                              const pastedData = e.clipboardData.getData("text");
                              if (!/^\d+$/.test(pastedData)) {
                                e.preventDefault();
                              }
                            }}
                            className={
                              formik.touched.mar_i_loan &&
                                formik.errors.mar_i_loan
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                          />
                        </td>
                      </tr>
                      <tr>
                        {" "}
                        <td
                          style={{
                            color: "black",
                            backgroundColor: "white",
                            fontWeight: "700",
                            fontFamily: "roboto",
                          }}
                        >
                          MEDI-Principal
                        </td>
                        <td>
                          <Field
                            name="med_a_loanpi"
                            onChange={(e) => {
                              formik.handleChange(e);
                            }}
                            type="text"
                            onKeyPress={(e) => NumberValidation(e)}
                            maxLength={15}
                            onPaste={(e) => {
                              const pastedData = e.clipboardData.getData("text");
                              if (!/^\d+$/.test(pastedData)) {
                                e.preventDefault();
                              }
                            }}
                            className={
                              formik.touched.med_a_loanpi &&
                                formik.errors.med_a_loanpi
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                          />
                        </td>
                        <td>
                          <Field
                            name="med_a_loanti"
                            onChange={(e) => {
                              formik.handleChange(e);
                            }}
                            type="text"
                            onKeyPress={(e) => NumberValidation(e)}
                            maxLength={15}
                            onPaste={(e) => {
                              const pastedData = e.clipboardData.getData("text");
                              if (!/^\d+$/.test(pastedData)) {
                                e.preventDefault();
                              }
                            }}
                            className={
                              formik.touched.med_a_loanti &&
                                formik.errors.med_a_loanti
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                          />
                        </td>
                        <td>
                          <Field
                            name="med_a_loan"
                            onChange={(e) => {
                              formik.handleChange(e);
                            }}
                            type="text"
                            onKeyPress={(e) => NumberValidation(e)}
                            maxLength={15}
                            onPaste={(e) => {
                              const pastedData = e.clipboardData.getData("text");
                              if (!/^\d+$/.test(pastedData)) {
                                e.preventDefault();
                              }
                            }}
                            className={
                              formik.touched.med_a_loan &&
                                formik.errors.med_a_loan
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                          />
                        </td>
                        <td
                          style={{
                            color: "black",
                            backgroundColor: "white",
                            fontWeight: "700",
                            fontFamily: "roboto",
                          }}
                        >
                          MEDI-Interest
                        </td>
                        <td>
                          <Field
                            name="med_a_i_loanpi"
                            onChange={(e) => {
                              formik.handleChange(e);
                            }}
                            type="text"
                            onKeyPress={(e) => NumberValidation(e)}
                            maxLength={15}
                            onPaste={(e) => {
                              const pastedData = e.clipboardData.getData("text");
                              if (!/^\d+$/.test(pastedData)) {
                                e.preventDefault();
                              }
                            }}
                            className={
                              formik.touched.med_a_i_loanpi &&
                                formik.errors.med_a_i_loanpi
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                          />
                        </td>
                        <td>
                          <Field
                            name="med_a_i_loanti"
                            onChange={(e) => {
                              formik.handleChange(e);
                            }}
                            type="text"
                            onKeyPress={(e) => NumberValidation(e)}
                            maxLength={15}
                            onPaste={(e) => {
                              const pastedData = e.clipboardData.getData("text");
                              if (!/^\d+$/.test(pastedData)) {
                                e.preventDefault();
                              }
                            }}
                            className={
                              formik.touched.med_a_i_loanti &&
                                formik.errors.med_a_i_loanti
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                          />
                        </td>
                        <td>
                          <Field
                            name="med_a_i_loan"
                            onChange={(e) => {
                              formik.handleChange(e);
                            }}
                            type="text"
                            onKeyPress={(e) => NumberValidation(e)}
                            maxLength={15}
                            onPaste={(e) => {
                              const pastedData = e.clipboardData.getData("text");
                              if (!/^\d+$/.test(pastedData)) {
                                e.preventDefault();
                              }
                            }}
                            className={
                              formik.touched.med_a_i_loan &&
                                formik.errors.med_a_i_loan
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                          />
                        </td>
                      </tr>
                      <tr>
                        {" "}
                        <td
                          style={{
                            color: "black",
                            backgroundColor: "white",
                            fontWeight: "700",
                            fontFamily: "roboto",
                          }}
                        >
                          HBA
                        </td>
                        <td>
                          <Field
                            name="hba_loanpi"
                            onChange={(e) => {
                              formik.handleChange(e);
                            }}
                            type="text"
                            onKeyPress={(e) => NumberValidation(e)}
                            maxLength={15}
                            onPaste={(e) => {
                              const pastedData = e.clipboardData.getData("text");
                              if (!/^\d+$/.test(pastedData)) {
                                e.preventDefault();
                              }
                            }}
                            className={
                              formik.touched.hba_loanpi &&
                                formik.errors.hba_loanpi
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                          />
                        </td>
                        <td>
                          <Field
                            name="hba_loanti"
                            onChange={(e) => {
                              formik.handleChange(e);
                            }}
                            type="text"
                            onKeyPress={(e) => NumberValidation(e)}
                            maxLength={15}
                            onPaste={(e) => {
                              const pastedData = e.clipboardData.getData("text");
                              if (!/^\d+$/.test(pastedData)) {
                                e.preventDefault();
                              }
                            }}
                            className={
                              formik.touched.hba_loanti &&
                                formik.errors.hba_loanti
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                          />
                        </td>
                        <td>
                          <Field
                            name="hba_loan"
                            onChange={(e) => {
                              formik.handleChange(e);
                            }}
                            type="text"
                            onKeyPress={(e) => NumberValidation(e)}
                            maxLength={15}
                            onPaste={(e) => {
                              const pastedData = e.clipboardData.getData("text");
                              if (!/^\d+$/.test(pastedData)) {
                                e.preventDefault();
                              }
                            }}
                            className={
                              formik.touched.hba_loan && formik.errors.hba_loan
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                          />
                        </td>
                        <td
                          style={{
                            color: "black",
                            backgroundColor: "white",
                            fontWeight: "700",
                            fontFamily: "roboto",
                          }}
                        >
                          HBA-Interest
                        </td>
                        <td>
                          <Field
                            name="hba1_loanpi"
                            onChange={(e) => {
                              formik.handleChange(e);
                            }}
                            type="text"
                            onKeyPress={(e) => NumberValidation(e)}
                            maxLength={15}
                            onPaste={(e) => {
                              const pastedData = e.clipboardData.getData("text");
                              if (!/^\d+$/.test(pastedData)) {
                                e.preventDefault();
                              }
                            }}
                            className={
                              formik.touched.hba1_loanpi &&
                                formik.errors.hba1_loanpi
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                          />
                        </td>
                        <td>
                          <Field
                            name="hba1_loanti"
                            onChange={(e) => {
                              formik.handleChange(e);
                            }}
                            type="text"
                            onKeyPress={(e) => NumberValidation(e)}
                            maxLength={15}
                            onPaste={(e) => {
                              const pastedData = e.clipboardData.getData("text");
                              if (!/^\d+$/.test(pastedData)) {
                                e.preventDefault();
                              }
                            }}
                            className={
                              formik.touched.hba1_loanti &&
                                formik.errors.hba1_loanti
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                          />
                        </td>
                        <td>
                          <Field
                            name="hba1_loan"
                            onChange={(e) => {
                              formik.handleChange(e);
                            }}
                            type="text"
                            onKeyPress={(e) => NumberValidation(e)}
                            maxLength={15}
                            onPaste={(e) => {
                              const pastedData = e.clipboardData.getData("text");
                              if (!/^\d+$/.test(pastedData)) {
                                e.preventDefault();
                              }
                            }}
                            className={
                              formik.touched.hba1_loan && formik.errors.hba1_loan
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                          />
                        </td>
                      </tr>
                      <tr>
                        {" "}
                        <td
                          style={{
                            color: "black",
                            backgroundColor: "white",
                            fontWeight: "700",
                            fontFamily: "roboto",
                          }}
                        >
                          ADD HBA
                        </td>
                        <td>
                          <Field
                            name="add_hba_loanpi"
                            onChange={(e) => {
                              formik.handleChange(e);
                            }}
                            type="text"
                            onKeyPress={(e) => NumberValidation(e)}
                            maxLength={15}
                            onPaste={(e) => {
                              const pastedData = e.clipboardData.getData("text");
                              if (!/^\d+$/.test(pastedData)) {
                                e.preventDefault();
                              }
                            }}
                            className={
                              formik.touched.add_hba_loanpi &&
                                formik.errors.add_hba_loanpi
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                          />
                        </td>
                        <td>
                          <Field
                            name="add_hba_loanti"
                            onChange={(e) => {
                              formik.handleChange(e);
                            }}
                            type="text"
                            onKeyPress={(e) => NumberValidation(e)}
                            maxLength={15}
                            onPaste={(e) => {
                              const pastedData = e.clipboardData.getData("text");
                              if (!/^\d+$/.test(pastedData)) {
                                e.preventDefault();
                              }
                            }}
                            className={
                              formik.touched.add_hba_loanti &&
                                formik.errors.add_hba_loanti
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                          />
                        </td>
                        <td>
                          <Field
                            name="add_hba_loan"
                            onChange={(e) => {
                              formik.handleChange(e);
                            }}
                            type="text"
                            onKeyPress={(e) => NumberValidation(e)}
                            maxLength={15}
                            onPaste={(e) => {
                              const pastedData = e.clipboardData.getData("text");
                              if (!/^\d+$/.test(pastedData)) {
                                e.preventDefault();
                              }
                            }}
                            className={
                              formik.touched.add_hba_loan &&
                                formik.errors.add_hba_loan
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                          />
                        </td>
                        <td
                          style={{
                            color: "black",
                            backgroundColor: "white",
                            fontWeight: "700",
                            fontFamily: "roboto",
                          }}
                        >
                          ADD HBA-Interest
                        </td>
                        <td>
                          <Field
                            name="add_hba1_loanpi"
                            onChange={(e) => {
                              formik.handleChange(e);
                            }}
                            type="text"
                            onKeyPress={(e) => NumberValidation(e)}
                            maxLength={15}
                            onPaste={(e) => {
                              const pastedData = e.clipboardData.getData("text");
                              if (!/^\d+$/.test(pastedData)) {
                                e.preventDefault();
                              }
                            }}
                            className={
                              formik.touched.add_hba1_loanpi &&
                                formik.errors.add_hba1_loanpi
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                          />
                        </td>
                        <td>
                          <Field
                            name="add_hba1_loanti"
                            onChange={(e) => {
                              formik.handleChange(e);
                            }}
                            type="text"
                            onKeyPress={(e) => NumberValidation(e)}
                            maxLength={15}
                            onPaste={(e) => {
                              const pastedData = e.clipboardData.getData("text");
                              if (!/^\d+$/.test(pastedData)) {
                                e.preventDefault();
                              }
                            }}
                            className={
                              formik.touched.add_hba1_loanti &&
                                formik.errors.add_hba1_loanti
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                          />
                        </td>
                        <td>
                          <Field
                            name="add_hba1_loan"
                            onChange={(e) => {
                              formik.handleChange(e);
                            }}
                            type="text"
                            onKeyPress={(e) => NumberValidation(e)}
                            maxLength={15}
                            onPaste={(e) => {
                              const pastedData = e.clipboardData.getData("text");
                              if (!/^\d+$/.test(pastedData)) {
                                e.preventDefault();
                              }
                            }}
                            className={
                              formik.touched.add_hba1_loan &&
                                formik.errors.add_hba1_loan
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                          />
                        </td>
                      </tr>
                      <tr>
                        {" "}
                        <td
                          style={{
                            color: "black",
                            backgroundColor: "white",
                            fontWeight: "700",
                            fontFamily: "roboto",
                          }}
                        >
                          Comp.Adv
                        </td>
                        <td>
                          <Field
                            name="comp_loanpi"
                            onChange={(e) => {
                              formik.handleChange(e);
                            }}
                            type="text"
                            onKeyPress={(e) => NumberValidation(e)}
                            maxLength={15}
                            onPaste={(e) => {
                              const pastedData = e.clipboardData.getData("text");
                              if (!/^\d+$/.test(pastedData)) {
                                e.preventDefault();
                              }
                            }}
                            className={
                              formik.touched.comp_loanpi &&
                                formik.errors.comp_loanpi
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                          />
                        </td>
                        <td>
                          <Field
                            name="comp_loanti"
                            onChange={(e) => {
                              formik.handleChange(e);
                            }}
                            type="text"
                            onKeyPress={(e) => NumberValidation(e)}
                            maxLength={15}
                            onPaste={(e) => {
                              const pastedData = e.clipboardData.getData("text");
                              if (!/^\d+$/.test(pastedData)) {
                                e.preventDefault();
                              }
                            }}
                            className={
                              formik.touched.comp_loanti &&
                                formik.errors.comp_loanti
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                          />
                        </td>
                        <td>
                          <Field
                            name="comp_loan"
                            onChange={(e) => {
                              formik.handleChange(e);
                            }}
                            type="text"
                            onKeyPress={(e) => NumberValidation(e)}
                            maxLength={15}
                            onPaste={(e) => {
                              const pastedData = e.clipboardData.getData("text");
                              if (!/^\d+$/.test(pastedData)) {
                                e.preventDefault();
                              }
                            }}
                            className={
                              formik.touched.comp_loan && formik.errors.comp_loan
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                          />
                        </td>
                        <td
                          style={{
                            color: "black",
                            backgroundColor: "white",
                            fontWeight: "700",
                            fontFamily: "roboto",
                          }}
                        >
                          Comp.Adv-Interest
                        </td>
                        <td>
                          <Field
                            name="comp1_loanti"
                            onChange={(e) => {
                              formik.handleChange(e);
                            }}
                            type="text"
                            onKeyPress={(e) => NumberValidation(e)}
                            maxLength={15}
                            onPaste={(e) => {
                              const pastedData = e.clipboardData.getData("text");
                              if (!/^\d+$/.test(pastedData)) {
                                e.preventDefault();
                              }
                            }}
                            className={
                              formik.touched.comp1_loanti &&
                                formik.errors.comp1_loanti
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                          />
                        </td>
                        <td>
                          <Field
                            name="comp1_loanpi"
                            onChange={(e) => {
                              formik.handleChange(e);
                            }}
                            type="text"
                            onKeyPress={(e) => NumberValidation(e)}
                            maxLength={15}
                            onPaste={(e) => {
                              const pastedData = e.clipboardData.getData("text");
                              if (!/^\d+$/.test(pastedData)) {
                                e.preventDefault();
                              }
                            }}
                            className={
                              formik.touched.comp1_loanpi &&
                                formik.errors.comp1_loanpi
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                          />
                        </td>
                        <td>
                          <Field
                            name="comp1_loan"
                            onChange={(e) => {
                              formik.handleChange(e);
                            }}
                            type="text"
                            onKeyPress={(e) => NumberValidation(e)}
                            maxLength={15}
                            onPaste={(e) => {
                              const pastedData = e.clipboardData.getData("text");
                              if (!/^\d+$/.test(pastedData)) {
                                e.preventDefault();
                              }
                            }}
                            className={
                              formik.touched.comp1_loan &&
                                formik.errors.comp1_loan
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                          />
                        </td>
                      </tr>
                      <tr>
                        {" "}
                        <td
                          style={{
                            color: "black",
                            backgroundColor: "white",
                            fontWeight: "700",
                            fontFamily: "roboto",
                          }}
                        >
                          HCESA-Principal
                        </td>
                        <td>
                          <Field
                            name="hcesa_loanpi"
                            onChange={(e) => {
                              formik.handleChange(e);
                            }}
                            type="text"
                            onKeyPress={(e) => NumberValidation(e)}
                            maxLength={15}
                            onPaste={(e) => {
                              const pastedData = e.clipboardData.getData("text");
                              if (!/^\d+$/.test(pastedData)) {
                                e.preventDefault();
                              }
                            }}
                            className={
                              formik.touched.hcesa_loanpi &&
                                formik.errors.hcesa_loanpi
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                          />
                        </td>
                        <td>
                          <Field
                            name="hcesa_loanti"
                            onChange={(e) => {
                              formik.handleChange(e);
                            }}
                            type="text"
                            onKeyPress={(e) => NumberValidation(e)}
                            maxLength={15}
                            onPaste={(e) => {
                              const pastedData = e.clipboardData.getData("text");
                              if (!/^\d+$/.test(pastedData)) {
                                e.preventDefault();
                              }
                            }}
                            className={
                              formik.touched.hcesa_loanti &&
                                formik.errors.hcesa_loanti
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                          />
                        </td>
                        <td>
                          <Field
                            name="hcesa_loan"
                            onChange={(e) => {
                              formik.handleChange(e);
                            }}
                            type="text"
                            onKeyPress={(e) => NumberValidation(e)}
                            maxLength={15}
                            onPaste={(e) => {
                              const pastedData = e.clipboardData.getData("text");
                              if (!/^\d+$/.test(pastedData)) {
                                e.preventDefault();
                              }
                            }}
                            className={
                              formik.touched.hcesa_loan &&
                                formik.errors.hcesa_loan
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                          />
                        </td>
                        <td
                          style={{
                            color: "black",
                            backgroundColor: "white",
                            fontWeight: "700",
                            fontFamily: "roboto",
                          }}
                        >
                          HCESA-Interest
                        </td>
                        <td>
                          <Field
                            name="hcesa_i_loanpi"
                            onChange={(e) => {
                              formik.handleChange(e);
                            }}
                            type="text"
                            onKeyPress={(e) => NumberValidation(e)}
                            maxLength={15}
                            onPaste={(e) => {
                              const pastedData = e.clipboardData.getData("text");
                              if (!/^\d+$/.test(pastedData)) {
                                e.preventDefault();
                              }
                            }}
                            className={
                              formik.touched.hcesa_i_loanpi &&
                                formik.errors.hcesa_i_loanpi
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                          />
                        </td>
                        <td>
                          <Field
                            name="hcesa_i_loanti"
                            onChange={(e) => {
                              formik.handleChange(e);
                            }}
                            type="text"
                            onKeyPress={(e) => NumberValidation(e)}
                            maxLength={15}
                            onPaste={(e) => {
                              const pastedData = e.clipboardData.getData("text");
                              if (!/^\d+$/.test(pastedData)) {
                                e.preventDefault();
                              }
                            }}
                            className={
                              formik.touched.hcesa_i_loanti &&
                                formik.errors.hcesa_i_loanti
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                          />
                        </td>
                        <td>
                          <Field
                            name="hcesa_i_loan"
                            onChange={(e) => {
                              formik.handleChange(e);
                            }}
                            type="text"
                            onKeyPress={(e) => NumberValidation(e)}
                            maxLength={15}
                            onPaste={(e) => {
                              const pastedData = e.clipboardData.getData("text");
                              if (!/^\d+$/.test(pastedData)) {
                                e.preventDefault();
                              }
                            }}
                            className={
                              formik.touched.hcesa_i_loan &&
                                formik.errors.hcesa_i_loan
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                          />
                        </td>
                      </tr>
                      <tr>
                        {" "}
                        <td
                          style={{
                            color: "black",
                            backgroundColor: "white",
                            fontWeight: "700",
                            fontFamily: "roboto",
                          }}
                        >
                          HBA-Other Dept.
                        </td>
                        <td>
                          <Field
                            name="hbao_loanpi"
                            onChange={(e) => {
                              formik.handleChange(e);
                            }}
                            type="text"
                            onKeyPress={(e) => NumberValidation(e)}
                            maxLength={15}
                            onPaste={(e) => {
                              const pastedData = e.clipboardData.getData("text");
                              if (!/^\d+$/.test(pastedData)) {
                                e.preventDefault();
                              }
                            }}
                            className={
                              formik.touched.hbao_loanpi &&
                                formik.errors.hbao_loanpi
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                          />
                        </td>
                        <td>
                          <Field
                            name="hbao_loanti"
                            onChange={(e) => {
                              formik.handleChange(e);
                            }}
                            type="text"
                            onKeyPress={(e) => NumberValidation(e)}
                            maxLength={15}
                            onPaste={(e) => {
                              const pastedData = e.clipboardData.getData("text");
                              if (!/^\d+$/.test(pastedData)) {
                                e.preventDefault();
                              }
                            }}
                            className={
                              formik.touched.hbao_loanti &&
                                formik.errors.hbao_loanti
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                          />
                        </td>
                        <td>
                          <Field
                            name="hbao_loan"
                            onChange={(e) => {
                              formik.handleChange(e);
                            }}
                            type="text"
                            onKeyPress={(e) => NumberValidation(e)}
                            maxLength={15}
                            onPaste={(e) => {
                              const pastedData = e.clipboardData.getData("text");
                              if (!/^\d+$/.test(pastedData)) {
                                e.preventDefault();
                              }
                            }}
                            className={
                              formik.touched.hbao_loan && formik.errors.hbao_loan
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                          />
                        </td>
                        <td
                          style={{
                            color: "black",
                            backgroundColor: "white",
                            fontWeight: "700",
                            fontFamily: "roboto",
                          }}
                        >
                          Personal Bank Loan
                        </td>
                        <td>
                          <Field
                            name="vij_bank_loanpi"
                            onChange={(e) => {
                              formik.handleChange(e);
                            }}
                            type="text"
                            onKeyPress={(e) => NumberValidation(e)}
                            maxLength={15}
                            onPaste={(e) => {
                              const pastedData = e.clipboardData.getData("text");
                              if (!/^\d+$/.test(pastedData)) {
                                e.preventDefault();
                              }
                            }}
                            className={
                              formik.touched.vij_bank_loanpi &&
                                formik.errors.vij_bank_loanpi
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                          />
                        </td>
                        <td>
                          <Field
                            name="vij_bank_loanti"
                            onChange={(e) => {
                              formik.handleChange(e);
                            }}
                            type="text"
                            onKeyPress={(e) => NumberValidation(e)}
                            maxLength={15}
                            onPaste={(e) => {
                              const pastedData = e.clipboardData.getData("text");
                              if (!/^\d+$/.test(pastedData)) {
                                e.preventDefault();
                              }
                            }}
                            className={
                              formik.touched.vij_bank_loanti &&
                                formik.errors.vij_bank_loanti
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                          />
                        </td>
                        <td>
                          <Field
                            name="vij_bank_loan"
                            onChange={(e) => {
                              formik.handleChange(e);
                            }}
                            type="text"
                            onKeyPress={(e) => NumberValidation(e)}
                            maxLength={15}
                            onPaste={(e) => {
                              const pastedData = e.clipboardData.getData("text");
                              if (!/^\d+$/.test(pastedData)) {
                                e.preventDefault();
                              }
                            }}
                            className={
                              formik.touched.vij_bank_loan &&
                                formik.errors.vij_bank_loan
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                          />
                        </td>
                      </tr>
                      <tr>
                        {" "}
                        <td
                          style={{
                            color: "black",
                            backgroundColor: "white",
                            fontWeight: "700",
                            fontFamily: "roboto",
                          }}
                        >
                          FA
                        </td>
                        <td>
                          <Field
                            name="fa_loanpi"
                            onChange={(e) => {
                              formik.handleChange(e);
                            }}
                            type="text"
                            onKeyPress={(e) => NumberValidation(e)}
                            maxLength={15}
                            onPaste={(e) => {
                              const pastedData = e.clipboardData.getData("text");
                              if (!/^\d+$/.test(pastedData)) {
                                e.preventDefault();
                              }
                            }}
                            className={
                              formik.touched.fa_loanpi && formik.errors.fa_loanpi
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                          />
                        </td>
                        <td>
                          <Field
                            name="fa_loanti"
                            onChange={(e) => {
                              formik.handleChange(e);
                            }}
                            type="text"
                            onKeyPress={(e) => NumberValidation(e)}
                            maxLength={15}
                            onPaste={(e) => {
                              const pastedData = e.clipboardData.getData("text");
                              if (!/^\d+$/.test(pastedData)) {
                                e.preventDefault();
                              }
                            }}
                            className={
                              formik.touched.fa_loanti && formik.errors.fa_loanti
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                          />
                        </td>
                        <td>
                          <Field
                            name="fa_loan"
                            onChange={(e) => {
                              formik.handleChange(e);
                            }}
                            type="text"
                            onKeyPress={(e) => NumberValidation(e)}
                            maxLength={15}
                            onPaste={(e) => {
                              const pastedData = e.clipboardData.getData("text");
                              if (!/^\d+$/.test(pastedData)) {
                                e.preventDefault();
                              }
                            }}
                            className={
                              formik.touched.fa_loan && formik.errors.fa_loan
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                          />
                        </td>
                        <td
                          style={{
                            color: "black",
                            backgroundColor: "white",
                            fontWeight: "700",
                            fontFamily: "roboto",
                          }}
                        >
                          EA
                        </td>
                        <td>
                          <Field
                            name="ea_loanpi"
                            onChange={(e) => {
                              formik.handleChange(e);
                            }}
                            type="text"
                            onKeyPress={(e) => NumberValidation(e)}
                            maxLength={15}
                            onPaste={(e) => {
                              const pastedData = e.clipboardData.getData("text");
                              if (!/^\d+$/.test(pastedData)) {
                                e.preventDefault();
                              }
                            }}
                            className={
                              formik.touched.ea_loanpi && formik.errors.ea_loanpi
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                          />
                        </td>
                        <td>
                          <Field
                            name="ea_loanti"
                            onChange={(e) => {
                              formik.handleChange(e);
                            }}
                            type="text"
                            onKeyPress={(e) => NumberValidation(e)}
                            maxLength={15}
                            onPaste={(e) => {
                              const pastedData = e.clipboardData.getData("text");
                              if (!/^\d+$/.test(pastedData)) {
                                e.preventDefault();
                              }
                            }}
                            className={
                              formik.touched.ea_loanti && formik.errors.ea_loanti
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                          />
                        </td>
                        <td>
                          <Field
                            name="ea_loan"
                            onChange={(e) => {
                              formik.handleChange(e);
                            }}
                            type="text"
                            onKeyPress={(e) => NumberValidation(e)}
                            maxLength={15}
                            onPaste={(e) => {
                              const pastedData = e.clipboardData.getData("text");
                              if (!/^\d+$/.test(pastedData)) {
                                e.preventDefault();
                              }
                            }}
                            className={
                              formik.touched.ea_loan && formik.errors.ea_loan
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                          />
                        </td>
                      </tr>
                      <tr>
                        {" "}
                        <td
                          style={{
                            color: "black",
                            backgroundColor: "white",
                            fontWeight: "700",
                            fontFamily: "roboto",
                          }}
                        >
                          Spl.FA
                        </td>
                        <td>
                          <Field
                            name="sfa_loanpi"
                            onChange={(e) => {
                              formik.handleChange(e);
                            }}
                            type="text"
                            onKeyPress={(e) => NumberValidation(e)}
                            maxLength={15}
                            onPaste={(e) => {
                              const pastedData = e.clipboardData.getData("text");
                              if (!/^\d+$/.test(pastedData)) {
                                e.preventDefault();
                              }
                            }}
                            className={
                              formik.touched.sfa_loanpi &&
                                formik.errors.sfa_loanpi
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                          />
                        </td>
                        <td>
                          <Field
                            name="sfa_loanti"
                            onChange={(e) => {
                              formik.handleChange(e);
                            }}
                            type="text"
                            onKeyPress={(e) => NumberValidation(e)}
                            maxLength={15}
                            onPaste={(e) => {
                              const pastedData = e.clipboardData.getData("text");
                              if (!/^\d+$/.test(pastedData)) {
                                e.preventDefault();
                              }
                            }}
                            className={
                              formik.touched.sfa_loanti &&
                                formik.errors.sfa_loanti
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                          />
                        </td>
                        <td>
                          <Field
                            name="sfa_loan"
                            onChange={(e) => {
                              formik.handleChange(e);
                            }}
                            type="text"
                            onKeyPress={(e) => NumberValidation(e)}
                            maxLength={15}
                            onPaste={(e) => {
                              const pastedData = e.clipboardData.getData("text");
                              if (!/^\d+$/.test(pastedData)) {
                                e.preventDefault();
                              }
                            }}
                            className={
                              formik.touched.sfa_loan && formik.errors.sfa_loan
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                          />
                        </td>
                        <td
                          style={{
                            color: "black",
                            backgroundColor: "white",
                            fontWeight: "700",
                            fontFamily: "roboto",
                          }}
                        >
                          Sal.Adv
                        </td>
                        <td>
                          <Field
                            name="sal_adv_loanpi"
                            onChange={(e) => {
                              formik.handleChange(e);
                            }}
                            type="text"
                            onKeyPress={(e) => NumberValidation(e)}
                            maxLength={15}
                            onPaste={(e) => {
                              const pastedData = e.clipboardData.getData("text");
                              if (!/^\d+$/.test(pastedData)) {
                                e.preventDefault();
                              }
                            }}
                            className={
                              formik.touched.sal_adv_loanpi &&
                                formik.errors.sal_adv_loanpi
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                          />
                        </td>
                        <td>
                          <Field
                            name="sal_adv_loanti"
                            onChange={(e) => {
                              formik.handleChange(e);
                            }}
                            type="text"
                            onKeyPress={(e) => NumberValidation(e)}
                            maxLength={15}
                            onPaste={(e) => {
                              const pastedData = e.clipboardData.getData("text");
                              if (!/^\d+$/.test(pastedData)) {
                                e.preventDefault();
                              }
                            }}
                            className={
                              formik.touched.sal_adv_loanti &&
                                formik.errors.sal_adv_loanti
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                          />
                        </td>
                        <td>
                          <Field
                            name="sal_adv_loan"
                            onChange={(e) => {
                              formik.handleChange(e);
                            }}
                            type="text"
                            onKeyPress={(e) => NumberValidation(e)}
                            maxLength={15}
                            onPaste={(e) => {
                              const pastedData = e.clipboardData.getData("text");
                              if (!/^\d+$/.test(pastedData)) {
                                e.preventDefault();
                              }
                            }}
                            className={
                              formik.touched.sal_adv_loan &&
                                formik.errors.sal_adv_loan
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                          />
                        </td>
                      </tr>
                      <tr>
                        {" "}
                        <td
                          style={{
                            color: "black",
                            backgroundColor: "white",
                            fontWeight: "700",
                            fontFamily: "roboto",
                          }}
                        >
                          HR Arrear
                        </td>
                        <td>
                          <Field
                            name="hr_arrear_loanpi"
                            onChange={(e) => {
                              formik.handleChange(e);
                            }}
                            type="text"
                            onKeyPress={(e) => NumberValidation(e)}
                            maxLength={15}
                            onPaste={(e) => {
                              const pastedData = e.clipboardData.getData("text");
                              if (!/^\d+$/.test(pastedData)) {
                                e.preventDefault();
                              }
                            }}
                            className={
                              formik.touched.hr_arrear_loanpi &&
                                formik.errors.hr_arrear_loanpi
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                          />
                        </td>
                        <td>
                          <Field
                            name="hr_arrear_loanti"
                            onChange={(e) => {
                              formik.handleChange(e);
                            }}
                            type="text"
                            onKeyPress={(e) => NumberValidation(e)}
                            maxLength={15}
                            onPaste={(e) => {
                              const pastedData = e.clipboardData.getData("text");
                              if (!/^\d+$/.test(pastedData)) {
                                e.preventDefault();
                              }
                            }}
                            className={
                              formik.touched.hr_arrear_loanti &&
                                formik.errors.hr_arrear_loanti
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                          />
                        </td>
                        <td>
                          <Field
                            name="hr_arrear_loan"
                            onChange={(e) => {
                              formik.handleChange(e);
                            }}
                            type="text"
                            onKeyPress={(e) => NumberValidation(e)}
                            maxLength={15}
                            onPaste={(e) => {
                              const pastedData = e.clipboardData.getData("text");
                              if (!/^\d+$/.test(pastedData)) {
                                e.preventDefault();
                              }
                            }}
                            className={
                              formik.touched.hr_arrear_loan &&
                                formik.errors.hr_arrear_loan
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                          />
                        </td>
                        <td
                          style={{
                            color: "black",
                            backgroundColor: "white",
                            fontWeight: "700",
                            fontFamily: "roboto",
                          }}
                        >
                          Cell/Telephone Charges
                        </td>
                        <td>
                          <Field
                            name="cell_loanpi"
                            onChange={(e) => {
                              formik.handleChange(e);
                            }}
                            type="text"
                            onKeyPress={(e) => NumberValidation(e)}
                            maxLength={15}
                            onPaste={(e) => {
                              const pastedData = e.clipboardData.getData("text");
                              if (!/^\d+$/.test(pastedData)) {
                                e.preventDefault();
                              }
                            }}
                            className={
                              formik.touched.cell_loanpi &&
                                formik.errors.cell_loanpi
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                          />
                        </td>
                        <td>
                          <Field
                            name="cell_loanti"
                            onChange={(e) => {
                              formik.handleChange(e);
                            }}
                            type="text"
                            onKeyPress={(e) => NumberValidation(e)}
                            maxLength={15}
                            onPaste={(e) => {
                              const pastedData = e.clipboardData.getData("text");
                              if (!/^\d+$/.test(pastedData)) {
                                e.preventDefault();
                              }
                            }}
                            className={
                              formik.touched.cell_loanti &&
                                formik.errors.cell_loanti
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                          />
                        </td>
                        <td>
                          <Field
                            name="cell_loan"
                            onChange={(e) => {
                              formik.handleChange(e);
                            }}
                            type="text"
                            onKeyPress={(e) => NumberValidation(e)}
                            maxLength={15}
                            onPaste={(e) => {
                              const pastedData = e.clipboardData.getData("text");
                              if (!/^\d+$/.test(pastedData)) {
                                e.preventDefault();
                              }
                            }}
                            className={
                              formik.touched.cell_loan && formik.errors.cell_loan
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                          />
                        </td>
                      </tr>
                      <tr>
                        {" "}
                        <td
                          style={{
                            color: "black",
                            backgroundColor: "white",
                            fontWeight: "700",
                            fontFamily: "roboto",
                          }}
                        >
                          Staff PL.
                        </td>
                        <td>
                          <Field
                            name="staff_pl_loanpi"
                            onChange={(e) => {
                              formik.handleChange(e);
                            }}
                            type="text"
                            onKeyPress={(e) => NumberValidation(e)}
                            maxLength={15}
                            onPaste={(e) => {
                              const pastedData = e.clipboardData.getData("text");
                              if (!/^\d+$/.test(pastedData)) {
                                e.preventDefault();
                              }
                            }}
                            className={
                              formik.touched.staff_pl_loanpi &&
                                formik.errors.staff_pl_loanpi
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                          />
                        </td>
                        <td>
                          <Field
                            name="staff_pl_loanti"
                            onChange={(e) => {
                              formik.handleChange(e);
                            }}
                            type="text"
                            onKeyPress={(e) => NumberValidation(e)}
                            maxLength={15}
                            onPaste={(e) => {
                              const pastedData = e.clipboardData.getData("text");
                              if (!/^\d+$/.test(pastedData)) {
                                e.preventDefault();
                              }
                            }}
                            className={
                              formik.touched.staff_pl_loanti &&
                                formik.errors.staff_pl_loanti
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                          />
                        </td>
                        <td>
                          <Field
                            name="staff_pl_loan"
                            onChange={(e) => {
                              formik.handleChange(e);
                            }}
                            type="text"
                            onKeyPress={(e) => NumberValidation(e)}
                            maxLength={15}
                            onPaste={(e) => {
                              const pastedData = e.clipboardData.getData("text");
                              if (!/^\d+$/.test(pastedData)) {
                                e.preventDefault();
                              }
                            }}
                            className={
                              formik.touched.staff_pl_loan &&
                                formik.errors.staff_pl_loan
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                          />
                        </td>
                        <td
                          style={{
                            color: "black",
                            backgroundColor: "white",
                            fontWeight: "700",
                            fontFamily: "roboto",
                          }}
                        >
                          Court
                        </td>
                        <td>
                          <Field
                            name="court_loanpi"
                            onChange={(e) => {
                              formik.handleChange(e);
                            }}
                            type="text"
                            onKeyPress={(e) => NumberValidation(e)}
                            maxLength={15}
                            onPaste={(e) => {
                              const pastedData = e.clipboardData.getData("text");
                              if (!/^\d+$/.test(pastedData)) {
                                e.preventDefault();
                              }
                            }}
                            className={
                              formik.touched.court_loanpi &&
                                formik.errors.court_loanpi
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                          />
                        </td>
                        <td>
                          <Field
                            name="court_loanti"
                            onChange={(e) => {
                              formik.handleChange(e);
                            }}
                            type="text"
                            onKeyPress={(e) => NumberValidation(e)}
                            maxLength={15}
                            onPaste={(e) => {
                              const pastedData = e.clipboardData.getData("text");
                              if (!/^\d+$/.test(pastedData)) {
                                e.preventDefault();
                              }
                            }}
                            className={
                              formik.touched.court_loanti &&
                                formik.errors.court_loanti
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                          />
                        </td>
                        <td>
                          <Field
                            name="court_loan"
                            onChange={(e) => {
                              formik.handleChange(e);
                            }}
                            type="text"
                            onKeyPress={(e) => NumberValidation(e)}
                            maxLength={15}
                            onPaste={(e) => {
                              const pastedData = e.clipboardData.getData("text");
                              if (!/^\d+$/.test(pastedData)) {
                                e.preventDefault();
                              }
                            }}
                            className={
                              formik.touched.court_loan &&
                                formik.errors.court_loan
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                          />
                        </td>
                      </tr>
                    </tbody>
                  </Table>
                  <OFMSUI.Row>
                    <OFMSUI.Col
                      xs={12}
                      sm={12}
                      md={12}
                      lg={2}
                      xl={2}
                      xxl={2}
                      className=""
                      style={{ marginLeft: "auto" }}
                    >
                      <th
                        style={{
                          fontFamily: "roboto",
                          color: "red",
                          fontWeight: "800",
                        }}
                      >
                        <u>Loan Advances Total</u>
                      </th>

                      <Field
                        name="totalloanAdvances"
                        className={
                          formik.touched.totalloanAdvances &&
                            formik.errors.totalloanAdvances
                            ? "form-control is-invalid"
                            : "form-control"
                        }
                        type="text"
                        onKeyPress={(e) => NumberValidation(e)}
                        value={LoanDeductions.reduce(
                          (total, LoanDeductions) =>
                            total +
                            parseFloat(formik.values[LoanDeductions] || 0),
                          0
                        ).toLocaleString({
                          style: "currency",
                          currency: "INR",
                          maximumFractionDigits: 0,
                        })}
                        readOnly
                        onChange={(e) => {
                          formik.handleChange(e);
                        }}
                      />
                    </OFMSUI.Col>
                  </OFMSUI.Row>
                  <OFMSUI.Row>
                    <OFMSUI.Col
                      xs={12}
                      sm={12}
                      md={12}
                      lg={2}
                      xl={2}
                      xxl={2}
                      className=""
                      style={{ marginLeft: "auto" }}
                    >
                      <th
                        style={{
                          fontFamily: "roboto",
                          color: "green",
                          fontWeight: "800",
                          fontSize: "",
                        }}
                      >
                        <u>Net Salary</u>
                      </th>

                      <Field
                        name="netSalary"
                        className={
                          formik.touched.netSalary && formik.errors.netSalary
                            ? "form-control is-invalid"
                            : "form-control"
                        }
                        type="text"
                        onKeyPress={(e) => NumberValidation(e)}
                        value={totalSum.toLocaleString({
                          style: "currency",
                          currency: "INR",
                          maximumFractionDigits: 0,
                        })}
                        readOnly
                        onChange={(e) => {
                          formik.handleChange(e);
                        }}
                      />
                    </OFMSUI.Col>
                  </OFMSUI.Row>
                </>
              )}
            {selectedEmpType === "3" && (
              <>
                <div style={{ textAlign: "left" }} id="Earnings_3">
                  <h5 style={{ color: "#004687" }}>
                    <b style={{ color: "#0e6793" }}>
                      <u>
                        {" "}
                        <h4 style={{ fontFamily: "times new roman" }}>
                          Earnings
                        </h4>
                      </u>
                    </b>
                  </h5>
                </div>
                <div class="col-md-60">
                  <OFMSUI.Row>
                    <OFMSUI.Col
                      xs={12}
                      sm={12}
                      md={12}
                      lg={3}
                      xl={3}
                      xxl={3}
                      className=""
                    >
                      <th style={{ fontFamily: "roboto" }}>Place of Work</th>

                      <Field
                        name="os_work_place"
                        className={
                          formik.touched.os_work_place &&
                            formik.errors.os_work_place
                            ? "form-control is-invalid"
                            : "form-control"
                        }
                        onChange={formik.handleChange}
                        maxLength={100}
                      />
                    </OFMSUI.Col>
                    <OFMSUI.Col
                      xs={12}
                      sm={12}
                      md={12}
                      lg={3}
                      xl={3}
                      xxl={3}
                      className=""
                    >
                      <th style={{ fontFamily: "roboto" }}> Location</th>

                      <Field
                        name="os_location"
                        className={
                          formik.touched.os_location &&
                            formik.errors.os_location
                            ? "form-control is-invalid"
                            : "form-control"
                        }
                        onChange={formik.handleChange}
                        maxLength={100}

                      />
                    </OFMSUI.Col>
                    <OFMSUI.Col
                      xs={12}
                      sm={12}
                      md={12}
                      lg={3}
                      xl={3}
                      xxl={3}
                      className=""
                    >
                      <th style={{ fontFamily: "roboto" }}> Basic Pay</th>

                      <Field
                        name="os_basic_pay_earnings"
                        onChange={(e) => {
                          formik.handleChange(e);
                        }}
                        type="text"
                        onKeyPress={(e) => NumberValidation(e)}
                        className={
                          formik.touched.os_basic_pay_earnings &&
                            formik.errors.os_basic_pay_earnings
                            ? "form-control is-invalid"
                            : "form-control"
                        }
                      />
                    </OFMSUI.Col>
                    <OFMSUI.Col
                      xs={12}
                      sm={12}
                      md={12}
                      lg={3}
                      xl={3}
                      xxl={3}
                      className=""
                    >
                      <th style={{ fontFamily: "roboto" }}> H.R.A</th>

                      <Field
                        name="os_hra_earnings"
                        onChange={(e) => {
                          formik.handleChange(e);
                        }}
                        type="text"
                        onKeyPress={(e) => NumberValidation(e)}
                        className={
                          formik.touched.os_hra_earnings &&
                            formik.errors.os_hra_earnings
                            ? "form-control is-invalid"
                            : "form-control"
                        }
                      />
                    </OFMSUI.Col>
                    <OFMSUI.Col
                      xs={12}
                      sm={12}
                      md={12}
                      lg={3}
                      xl={3}
                      xxl={3}
                      className=""
                    >
                      <th style={{ fontFamily: "roboto" }}>Medical</th>

                      <Field
                        name="os_medical_earnings"
                        onChange={(e) => {
                          formik.handleChange(e);
                        }}
                        type="text"
                        onKeyPress={(e) => NumberValidation(e)}
                        className={
                          formik.touched.os_medical_earnings &&
                            formik.errors.os_medical_earnings
                            ? "form-control is-invalid"
                            : "form-control"
                        }
                      />
                    </OFMSUI.Col>
                    <OFMSUI.Col
                      xs={12}
                      sm={12}
                      md={12}
                      lg={3}
                      xl={3}
                      xxl={3}
                      className=""
                    >
                      <th style={{ fontFamily: "roboto" }}>C.A</th>

                      <Field
                        name="os_ca_earnings"
                        onChange={(e) => {
                          formik.handleChange(e);
                        }}
                        type="text"
                        onKeyPress={(e) => NumberValidation(e)}
                        className={
                          formik.touched.os_ca_earnings &&
                            formik.errors.os_ca_earnings
                            ? "form-control is-invalid"
                            : "form-control"
                        }
                      />
                    </OFMSUI.Col>
                    <OFMSUI.Col
                      xs={12}
                      sm={12}
                      md={12}
                      lg={3}
                      xl={3}
                      xxl={3}
                      className=""
                    >
                      <th style={{ fontFamily: "roboto" }}>Performance</th>

                      <Field
                        name="os_performance_earnings"
                        onChange={(e) => {
                          formik.handleChange(e);
                        }}
                        className={
                          formik.touched.os_performance_earnings &&
                            formik.errors.os_performance_earnings
                            ? "form-control is-invalid"
                            : "form-control"
                        }
                        type="text"
                        onKeyPress={(e) => NumberValidation(e)}
                      />
                    </OFMSUI.Col>
                    <OFMSUI.Col
                      xs={12}
                      sm={12}
                      md={12}
                      lg={3}
                      xl={3}
                      xxl={3}
                      className=""
                    >
                      <th style={{ fontFamily: "roboto" }}>
                        Employer's Contribution to EPF
                      </th>

                      <Field
                        name="os_ec_epf"
                        onChange={(e) => {
                          formik.handleChange(e);
                        }}
                        className={
                          formik.touched.os_ec_epf && formik.errors.os_ec_epf
                            ? "form-control is-invalid"
                            : "form-control"
                        }
                        type="text"
                        onKeyPress={(e) => NumberValidation(e)}
                      />
                    </OFMSUI.Col>
                  </OFMSUI.Row>
                </div>
                <OFMSUI.Row>
                  <OFMSUI.Col
                    xs={12}
                    sm={12}
                    md={12}
                    lg={2}
                    xl={2}
                    xxl={2}
                    className=""
                    style={{ marginLeft: "auto" }}
                  >
                    <th
                      style={{
                        fontFamily: "roboto",
                        color: "green",
                        fontWeight: "800",
                      }}
                    >
                      <u>Earnings Total</u>
                    </th>

                    <Field
                      name="totalEarnings_3"
                      className={
                        formik.touched.totalEarnings_3 &&
                          formik.errors.totalEarnings_3
                          ? "form-control is-invalid"
                          : "form-control"
                      }
                      type="text"
                      onKeyPress={(e) => NumberValidation(e)}
                      value={Earnings_3.reduce(
                        (total, Earnings_3) =>
                          total + parseFloat(formik.values[Earnings_3] || 0),
                        0
                      ).toLocaleString({
                        style: "currency",
                        currency: "INR",
                        maximumFractionDigits: 0,
                      })}
                      readOnly
                      onChange={(e) => {
                        formik.handleChange(e);
                      }}
                    />
                  </OFMSUI.Col>
                </OFMSUI.Row>
                <div style={{ textAlign: "left" }} id="Deductions_3">
                  <h5 style={{ color: "#004687" }}>
                    <b style={{ color: "#0e6793" }}>
                      <u>
                        {" "}
                        <h4 style={{ fontFamily: "times new roman" }}>
                          Deductions
                        </h4>
                      </u>
                    </b>
                  </h5>
                </div>
                <div class="col-md-60">
                  <OFMSUI.Row>
                    <OFMSUI.Col
                      xs={12}
                      sm={12}
                      md={12}
                      lg={3}
                      xl={3}
                      xxl={3}
                      className=""
                    >
                      <th style={{ fontFamily: "roboto" }}>
                        {" "}
                        Employees Share(EPF)
                      </th>

                      <Field
                        name="os_ees_epf_deductions"
                        className={
                          formik.touched.os_ees_epf_deductions &&
                            formik.errors.os_ees_epf_deductions
                            ? "form-control is-invalid"
                            : "form-control"
                        }
                        onChange={formik.handleChange}
                        onKeyPress={(e) => NumberValidation(e)}
                      />
                    </OFMSUI.Col>
                    <OFMSUI.Col
                      xs={12}
                      sm={12}
                      md={12}
                      lg={3}
                      xl={3}
                      xxl={3}
                      className=""
                    >
                      <th style={{ fontFamily: "roboto" }}>
                        Employers Share(EPF)
                      </th>

                      <Field
                        name="os_ers_epf_deductions"
                        className={
                          formik.touched.os_ers_epf_deductions &&
                            formik.errors.os_ers_epf_deductions
                            ? "form-control is-invalid"
                            : "form-control"
                        }
                        onChange={formik.handleChange}
                        onKeyPress={(e) => NumberValidation(e)}
                      />
                    </OFMSUI.Col>
                    <OFMSUI.Col
                      xs={12}
                      sm={12}
                      md={12}
                      lg={3}
                      xl={3}
                      xxl={3}
                      className=""
                    >
                      <th style={{ fontFamily: "roboto" }}>
                        {" "}
                        Professional Tax
                      </th>

                      <Field
                        name="os_prof_tax_deductions"
                        onChange={(e) => {
                          formik.handleChange(e);
                        }}
                        type="text"
                        onKeyPress={(e) => NumberValidation(e)}
                        className={
                          formik.touched.os_prof_tax_deductions &&
                            formik.errors.os_prof_tax_deductions
                            ? "form-control is-invalid"
                            : "form-control"
                        }
                      />
                    </OFMSUI.Col>
                    <OFMSUI.Col
                      xs={12}
                      sm={12}
                      md={12}
                      lg={3}
                      xl={3}
                      xxl={3}
                      className=""
                    >
                      <th style={{ fontFamily: "roboto" }}>
                        {" "}
                        Other Liabilities
                      </th>

                      <Field
                        name="os_other_deductions"
                        onChange={(e) => {
                          formik.handleChange(e);
                        }}
                        type="text"
                        onKeyPress={(e) => NumberValidation(e)}
                        className={
                          formik.touched.os_other_deductions &&
                            formik.errors.os_other_deductions
                            ? "form-control is-invalid"
                            : "form-control"
                        }
                      />
                    </OFMSUI.Col>
                  </OFMSUI.Row>
                </div>
                <OFMSUI.Row>
                  <OFMSUI.Col
                    xs={12}
                    sm={12}
                    md={12}
                    lg={2}
                    xl={2}
                    xxl={2}
                    className=""
                    style={{ marginLeft: "auto" }}
                  >
                    <th
                      style={{
                        fontFamily: "roboto",
                        color: "red",
                        fontWeight: "800",
                      }}
                    >
                      <u>Deductions Total</u>
                    </th>

                    <Field
                      name="totalDeductions_3"
                      className={
                        formik.touched.totalDeductions_3 &&
                          formik.errors.totalDeductions_3
                          ? "form-control is-invalid"
                          : "form-control"
                      }
                      type="text"
                      onKeyPress={(e) => NumberValidation(e)}
                      value={Deductions_3.reduce(
                        (total, Deductions_3) =>
                          total + parseFloat(formik.values[Deductions_3] || 0),
                        0
                      ).toLocaleString({
                        style: "currency",
                        currency: "INR",
                        maximumFractionDigits: 0,
                      })}
                      readOnly
                      onChange={(e) => {
                        formik.handleChange(e);
                      }}
                    />
                  </OFMSUI.Col>
                </OFMSUI.Row>

                <OFMSUI.Row>
                  <OFMSUI.Col
                    xs={12}
                    sm={12}
                    md={12}
                    lg={2}
                    xl={2}
                    xxl={2}
                    className=""
                    style={{ marginLeft: "auto" }}
                  >
                    <th
                      style={{
                        fontFamily: "roboto",
                        color: "green",
                        fontWeight: "800",
                        fontSize: "",
                      }}
                    >
                      <u>NET SALARY</u>
                    </th>

                    <Field
                      name="netSalary_3"
                      className={
                        formik.touched.netSalary_3 && formik.errors.netSalary_3
                          ? "form-control is-invalid"
                          : "form-control"
                      }
                      type="text"
                      onKeyPress={(e) => NumberValidation(e)}
                      value={totalSum_3.toLocaleString({
                        style: "currency",
                        currency: "INR",
                        maximumFractionDigits: 0,
                      })}
                      readOnly
                      onChange={(e) => {
                        formik.handleChange(e);
                      }}
                    />
                  </OFMSUI.Col>
                </OFMSUI.Row>
              </>
            )}
            {selectedEmpType === "4" && (
              <>
                <div style={{ textAlign: "left" }} id="Earnings_3">
                  <h5 style={{ color: "#004687" }}>
                    <b style={{ color: "#0e6793" }}>
                      <u>
                        {" "}
                        <h4 style={{ fontFamily: "times new roman" }}>
                          Earnings
                        </h4>
                      </u>
                    </b>
                  </h5>
                </div>
                <div class="col-md-60">
                  <OFMSUI.Row>
                    <OFMSUI.Col
                      xs={12}
                      sm={12}
                      md={12}
                      lg={3}
                      xl={3}
                      xxl={3}
                      className=""
                    >
                      <th style={{ fontFamily: "roboto" }}>Place of Work</th>

                      <Field
                        name="os_work_place"
                        className={
                          formik.touched.os_work_place &&
                            formik.errors.os_work_place
                            ? "form-control is-invalid"
                            : "form-control"
                        }
                        onChange={formik.handleChange}
                        maxLength={100}
                      />
                    </OFMSUI.Col>
                    <OFMSUI.Col
                      xs={12}
                      sm={12}
                      md={12}
                      lg={3}
                      xl={3}
                      xxl={3}
                      className=""
                    >
                      <th style={{ fontFamily: "roboto" }}> Location</th>

                      <Field
                        name="os_location"
                        className={
                          formik.touched.os_location &&
                            formik.errors.os_location
                            ? "form-control is-invalid"
                            : "form-control"
                        }
                        maxLength={100}
                        onChange={formik.handleChange}
                      />
                    </OFMSUI.Col>
                    <OFMSUI.Col
                      xs={12}
                      sm={12}
                      md={12}
                      lg={3}
                      xl={3}
                      xxl={3}
                      className=""
                    >
                      <th style={{ fontFamily: "roboto" }}> Earnings</th>

                      <Field
                        name="nmr_gross_earnings"
                        className={
                          formik.touched.nmr_gross_earnings &&
                            formik.errors.nmr_gross_earnings
                            ? "form-control is-invalid"
                            : "form-control"
                        }
                        onChange={formik.handleChange}
                      />
                    </OFMSUI.Col>
                  </OFMSUI.Row>
                </div>
                <OFMSUI.Row>
                  <OFMSUI.Col
                    xs={12}
                    sm={12}
                    md={12}
                    lg={2}
                    xl={2}
                    xxl={2}
                    className=""
                    style={{ marginLeft: "auto" }}
                  >
                    <th
                      style={{
                        fontFamily: "roboto",
                        color: "darkgreen",
                        fontWeight: "800",
                      }}
                    >
                      <u>Gross Earnings</u>
                    </th>

                    <Field
                      name="totalEarnings_4"
                      className={
                        formik.touched.totalEarnings_4 &&
                          formik.errors.totalEarnings_4
                          ? "form-control is-invalid"
                          : "form-control"
                      }
                      type="text"
                      onKeyPress={(e) => NumberValidation(e)}
                      value={Earnings_4.reduce(
                        (total, Earnings_4) =>
                          total + parseFloat(formik.values[Earnings_4] || 0),
                        0
                      ).toLocaleString({
                        style: "currency",
                        currency: "INR",
                        maximumFractionDigits: 0,
                      })}
                      readOnly
                      onChange={(e) => {
                        formik.handleChange(e);
                      }}
                    />
                  </OFMSUI.Col>
                </OFMSUI.Row>
                <div style={{ textAlign: "left" }} id="Deductions_3">
                  <h5 style={{ color: "#004687" }}>
                    <b style={{ color: "#0e6793" }}>
                      <u>
                        {" "}
                        <h4 style={{ fontFamily: "times new roman" }}>
                          Deductions
                        </h4>
                      </u>
                    </b>
                  </h5>
                </div>
                <div class="col-md-60">
                  <OFMSUI.Row>
                    <OFMSUI.Col
                      xs={12}
                      sm={12}
                      md={12}
                      lg={3}
                      xl={3}
                      xxl={3}
                      className=""
                    >
                      <th style={{ fontFamily: "roboto" }}>EPF</th>

                      <Field
                        name="os_ees_epf_deductions"
                        className={
                          formik.touched.os_ees_epf_deductions &&
                            formik.errors.os_ees_epf_deductions
                            ? "form-control is-invalid"
                            : "form-control"
                        }
                        onChange={formik.handleChange}
                      />
                    </OFMSUI.Col>
                    <OFMSUI.Col
                      xs={12}
                      sm={12}
                      md={12}
                      lg={3}
                      xl={3}
                      xxl={3}
                      className=""
                    >
                      <th style={{ fontFamily: "roboto" }}>
                        {" "}
                        Professional Tax
                      </th>

                      <Field
                        name="os_prof_tax_deductions"
                        className={
                          formik.touched.os_prof_tax_deductions &&
                            formik.errors.os_prof_tax_deductions
                            ? "form-control is-invalid"
                            : "form-control"
                        }
                        onChange={formik.handleChange}
                      />
                    </OFMSUI.Col>
                    <OFMSUI.Col
                      xs={12}
                      sm={12}
                      md={12}
                      lg={3}
                      xl={3}
                      xxl={3}
                      className=""
                    >
                      <th style={{ fontFamily: "roboto" }}> TDS</th>

                      <Field
                        name="nmr_tds_deductions"
                        onChange={(e) => {
                          formik.handleChange(e);
                        }}
                        type="text"
                        onKeyPress={(e) => NumberValidation(e)}
                        className={
                          formik.touched.nmr_tds_deductions &&
                            formik.errors.nmr_tds_deductions
                            ? "form-control is-invalid"
                            : "form-control"
                        }
                      />
                    </OFMSUI.Col>

                    <OFMSUI.Col
                      xs={12}
                      sm={12}
                      md={12}
                      lg={3}
                      xl={3}
                      xxl={3}
                      className=""
                    >
                      <th style={{ fontFamily: "roboto" }}> FA</th>

                      <Field
                        name="nmr_fa_deductions"
                        onChange={(e) => {
                          formik.handleChange(e);
                        }}
                        type="text"
                        onKeyPress={(e) => NumberValidation(e)}
                        className={
                          formik.touched.nmr_fa_deductions &&
                            formik.errors.nmr_fa_deductions
                            ? "form-control is-invalid"
                            : "form-control"
                        }
                      />
                    </OFMSUI.Col>
                    <OFMSUI.Col
                      xs={12}
                      sm={12}
                      md={12}
                      lg={3}
                      xl={3}
                      xxl={3}
                      className=""
                    >
                      <th style={{ fontFamily: "roboto" }}> EA</th>

                      <Field
                        name="nmr_ea_deductions"
                        onChange={(e) => {
                          formik.handleChange(e);
                        }}
                        type="text"
                        onKeyPress={(e) => NumberValidation(e)}
                        className={
                          formik.touched.nmr_ea_deductions &&
                            formik.errors.nmr_ea_deductions
                            ? "form-control is-invalid"
                            : "form-control"
                        }
                      />
                    </OFMSUI.Col>
                    <OFMSUI.Col
                      xs={12}
                      sm={12}
                      md={12}
                      lg={3}
                      xl={3}
                      xxl={3}
                      className=""
                    >
                      <th style={{ fontFamily: "roboto" }}> MA</th>

                      <Field
                        name="nmr_ma_deductions"
                        onChange={(e) => {
                          formik.handleChange(e);
                        }}
                        type="text"
                        onKeyPress={(e) => NumberValidation(e)}
                        className={
                          formik.touched.nmr_ma_deductions &&
                            formik.errors.nmr_ma_deductions
                            ? "form-control is-invalid"
                            : "form-control"
                        }
                      />
                    </OFMSUI.Col>
                    <OFMSUI.Col
                      xs={12}
                      sm={12}
                      md={12}
                      lg={3}
                      xl={3}
                      xxl={3}
                      className=""
                    >
                      <th style={{ fontFamily: "roboto" }}> LIC</th>

                      <Field
                        name="nmr_lic_deductions"
                        onChange={(e) => {
                          formik.handleChange(e);
                        }}
                        type="text"
                        onKeyPress={(e) => NumberValidation(e)}
                        className={
                          formik.touched.nmr_lic_deductions &&
                            formik.errors.nmr_lic_deductions
                            ? "form-control is-invalid"
                            : "form-control"
                        }
                      />
                    </OFMSUI.Col>
                    <OFMSUI.Col
                      xs={12}
                      sm={12}
                      md={12}
                      lg={3}
                      xl={3}
                      xxl={3}
                      className=""
                    >
                      <th style={{ fontFamily: "roboto" }}>
                        {" "}
                        Other Liabilities
                      </th>

                      <Field
                        name="nmr_otherliab_deductions"
                        onChange={(e) => {
                          formik.handleChange(e);
                        }}
                        type="text"
                        onKeyPress={(e) => NumberValidation(e)}
                        className={
                          formik.touched.nmr_otherliab_deductions &&
                            formik.errors.nmr_otherliab_deductions
                            ? "form-control is-invalid"
                            : "form-control"
                        }
                      />
                    </OFMSUI.Col>
                    <OFMSUI.Col
                      xs={12}
                      sm={12}
                      md={12}
                      lg={3}
                      xl={3}
                      xxl={3}
                      className=""
                    >
                      <th style={{ fontFamily: "roboto" }}> Postal RD</th>

                      <Field
                        name="nmr_postalrd_deductions"
                        onChange={(e) => {
                          formik.handleChange(e);
                        }}
                        type="text"
                        onKeyPress={(e) => NumberValidation(e)}
                        className={
                          formik.touched.nmr_postalrd_deductions &&
                            formik.errors.nmr_postalrd_deductions
                            ? "form-control is-invalid"
                            : "form-control"
                        }
                      />
                    </OFMSUI.Col>
                  </OFMSUI.Row>
                </div>
                <OFMSUI.Row>
                  <OFMSUI.Col
                    xs={12}
                    sm={12}
                    md={12}
                    lg={2}
                    xl={2}
                    xxl={2}
                    className=""
                    style={{ marginLeft: "auto" }}
                  >
                    <th
                      style={{
                        fontFamily: "roboto",
                        color: "red",
                        fontWeight: "800",
                      }}
                    >
                      <u>Deductions Total</u>
                    </th>

                    <Field
                      name="totalDeductions_4"
                      className={
                        formik.touched.totalDeductions_4 &&
                          formik.errors.totalDeductions_4
                          ? "form-control is-invalid"
                          : "form-control"
                      }
                      type="text"
                      onKeyPress={(e) => NumberValidation(e)}
                      value={Deductions_4.reduce(
                        (total, Deductions_4) =>
                          total + parseFloat(formik.values[Deductions_4] || 0),
                        0
                      ).toLocaleString({
                        style: "currency",
                        currency: "INR",
                        maximumFractionDigits: 0,
                      })}
                      readOnly
                      onChange={(e) => {
                        formik.handleChange(e);
                      }}
                    />
                  </OFMSUI.Col>
                </OFMSUI.Row>

                <OFMSUI.Row>
                  <OFMSUI.Col
                    xs={12}
                    sm={12}
                    md={12}
                    lg={2}
                    xl={2}
                    xxl={2}
                    className=""
                    style={{ marginLeft: "auto" }}
                  >
                    <th
                      style={{
                        fontFamily: "roboto",
                        color: "green",
                        fontWeight: "800",
                        fontSize: "",
                      }}
                    >
                      <u>NET SALARY</u>
                    </th>

                    <Field
                      name="netSalary_4"
                      className={
                        formik.touched.netSalary_4 && formik.errors.netSalary_4
                          ? "form-control is-invalid"
                          : "form-control"
                      }
                      type="text"
                      onKeyPress={(e) => NumberValidation(e)}
                      value={totalSum_4.toLocaleString({
                        style: "currency",
                        currency: "INR",
                        maximumFractionDigits: 0,
                      })}
                      readOnly
                      onChange={(e) => {
                        formik.handleChange(e);
                      }}
                    />
                  </OFMSUI.Col>
                </OFMSUI.Row>
              </>
            )}
            {(selectedEmpType === "1" ||
              selectedEmpType === "2" ||
              selectedEmpType === "5") && (
                <center>
                  <button
                    type="submit"
                    className="btn btn-success btn-sm"
                  // onClick={() => ConfirmEmpUpdateReport()}
                  >
                    Submit
                  </button>
                </center>
              )}
            {selectedEmpType === "3" && (
              <center>
                <button
                  type="submit"
                  className="btn btn-success btn-sm"
                // onClick={() => ConfirmEmpUpdateReport3()}
                >
                  Submit
                </button>
              </center>
            )}
            {selectedEmpType === "4" && (
              <center>
                <button
                  type="submit"
                  className="btn btn-success btn-sm"
                // onClick={() => ConfirmEmpUpdateReport4()}
                >
                  Submit
                </button>
              </center>
            )}
          </Form>
        </FormikProvider>
      </OFMSUI.Container>
    </>
  );
}
export default NewEmpRegistration;
